export const de = {
  nav: {
    overview: "Übersicht",
    accounts: "Konten",
    payouts: "Auszahlungen",
    affiliate: "Affiliate",
    support: "Support"
  },
  dashboardheader: {
    serverTime: "Server Zeit",
    wallet: "Wallet",
    settings: "Einstellungen",
    logout: "Abmelden",
    goToProfile: "Zum Profil"
  },
  protectedLayout: {
    connecting: {
      title: "Verbindung wird hergestellt",
      authenticating: "Authentifizierung läuft...",
      establishing: "Verbindung wird aufgebaut..."
    },
    connectionLost: {
      title: "Keine Verbindung zum Server",
      description: "Die Verbindung wurde unterbrochen. Wir versuchen automatisch, die Verbindung wiederherzustellen.",
      possibleCauses: "Mögliche Ursachen:",
      causes: {
        internet: "Ihre Internetverbindung wurde unterbrochen",
        maintenance: "Der Server führt aktuell Wartungsarbeiten durch",
        firewall: "Ihre Firewall oder Proxy blockiert die Verbindung",
        sleep: "Ihr Gerät ist in den Ruhemodus gewechselt"
      },
      reconnecting: "Verbindung wird wiederhergestellt...",
      attempt: "Versuch",
      waiting: "Warte auf Verbindung...",
      reloadButton: "Seite manuell neu laden"
    },
    connectionRestored: {
      title: "Verbindung wiederhergestellt",
      message: "Verbunden mit Server"
    }
  },
  accountCards: {
    title: "Trading-Konten",
    addAccount: "Konto hinzufügen",
    selectMultiple: "Mehrere auswählen",
    cancelSelection: "Abbrechen",
    backToAccounts: "Zurück zu Konten",
    balance: "Kontostand",
    days: "Handelstage",
    maxLots: "Max Lots",
    drawdown: "Drawdown",
    finalPnL: "Finaler G&V",
    current: "Aktuell",
    target: "Ziel",
    evaluationFailed: "Eval fehlgeschlagen",
    evaluationPassed: "Eval bestanden",
    evaluationPassedTitle: "Herzlichen Glückwunsch!",
    congratulationsSuccess: "Sie haben Ihre Evaluierung erfolgreich bestanden",
    resetAccount: "Konto zurücksetzen",
    extendAccount: "Konto verlängern",
    signFundedAgreement: "Funded-Konto aktivieren",
    awaitingFundedFee: "Warten auf Funded Fee",
    payFundedFee: "Funded Fee zahlen",
    contractSigned: "Vertrag unterschrieben - Zahlung erforderlich",
    livePnL: "Live G&V",
    today: "heute",
    since: "Seit: ",
    started: "Gestartet: ",
    passed: "Bestanden: ",
    failed: "Fehlgeschlagen: ",
    expired: "Abgelaufen: ",
    open: "Öffnen",
    accountExpired: "Konto abgelaufen",
    timeExpired: "Zeit abgelaufen",
    accountPeriodEnded: "Die Kontoperiode ist beendet",
    daysUntilClosure: "Du hast nur noch {{days}} Tage um das Konto zu verlängern, ansonsten wird es geschlossen.",
    deactivationReasons: {
      "Rule Violation": "Regelverstoss"
    },
    ruleViolations: {
      "Max Drawdown exceeded": "Maximaler Drawdown überschritten",
      "Trading outside permitted hours": "Trading außerhalb der erlaubten Zeiten",
      "Traded more contracts than permitted": "Mehr Kontrakte gehandelt als erlaubt"
    },
    expiryWarning: "Konto läuft bald ab",
    expiresIn: "Konto läuft in {{days}} Tag(en) ab",
    noAccountsTitle: "Noch keine Trading-Konten",
    noAccountsDescription: "Beginnen Sie mit dem Kauf Ihres ersten Evaluierungskontos und starten Sie Ihre Reise zum gefundeten Trader",
    fastSetup: "Schnelle Einrichtung",
    instantAccess: "Sofortiger Zugang",
    noHiddenFees: "Keine versteckten Gebühren",
    status: {
      active: "Aktiv",
      inProgress: "EVALUIERUNG",
      passed: "Bestanden",
      failed: "Fehlgeschlagen",
      expired: "Abgelaufen"
    },
    filters: {
      all: "Alle",
      funded: "Funded",
      evaluation: "Evaluierung",
      active: "Aktive",
      inactive: "Inaktive",
      resettable: "Zurücksetzbar",
      expired: "Abgelaufen",
      noResults: "Keine Konten entsprechen diesem Filter",
      showAll: "Alle Konten anzeigen"
    }
  },
  accountInformation: {
    title: "Kontoinformationen",
    accountTimeline: "Konto-Zeitplan",
    accountSize: "Kontogröße",
    dataFeed: "Datenfeed",
    loginCredentials: "Login-Daten",
    username: "Benutzername",
    password: "Passwort",
    server: "Server",
    copy: "Kopieren",
    important: "Wichtig",
    credentialsNote: "Verwenden Sie diese Anmeldedaten, um sich in Ihre {dataFeed}-Plattform einzuloggen. Halten Sie sie sicher und teilen Sie sie mit niemandem.",
    startDate: "Startdatum",
    expiryDate: "Ablaufdatum",
    daysRemaining: "Verbleibende Tage",
    days: "Tage",
    extend: "Verlängern",
    extendAccount: "Konto verlängern",
    resetBalance: "Zurücksetzen",
    tradingSpecifications: "Trading-Spezifikationen",
    maxPositionSize: "Max. Lots",
    profitTarget: "Gewinnziel",
    maxDrawdown: "Max. Drawdown",
    tradingHours: "Handelszeiten",
    accountPeriodEnded: "Die Kontoperiode ist beendet"
  },
  accountSelector: {
    title: "Konto-Analytik",
    analytics: "Live-Analytik",
    description: "Echtzeit-Performance-Tracking",
    liveData: "Live-Daten",
    account: "Konto",
    status: "Status"
  },
  performanceMetrics: {
    accountBalance: "Kontostand",
    netProfit: "Netto Gewinn",
    todaysPnL: "Heutiger G&V",
    winRate: "Gewinnrate",
    tradingDays: "Trading-Tage",
    vsYesterday: "vs gestern",
    trades: "Trades",
    totalExecuted: "Gesamt ausgeführt",
    activeDays: "Aktive Tage",
    allTime: "Alle Zeit"
  },
  performanceChart: {
    title: "Performance-Chart",
    subtitle: "Kontostand über Zeit",
    balance: "Guthaben",
    pnl: "P&L",
    percentage: "Prozent",
    currentBalance: "Aktueller Kontostand",
    drawdownLimit: "Drawdown-Limit",
    profitFactor: "Profit-Faktor",
    avgWinLoss: "Durchschn. Gewinn/Verlust",
    target: "Ziel",
    unlimited: "Unbegrenzt",
    limit: "Limit",
    start: "Start",
    hoverForDetails: "Datenpunkte im Diagramm hovern für Details"
  },
  pnlBreakdown: {
    title: "G&V Aufschlüsselung",
    subtitle: "Gewinn- und Verlustanalyse",
    bySymbol: "Nach Symbol",
    byTime: "Nach Zeit",
    grossProfit: "Bruttogewinn",
    grossLoss: "Bruttoverlust",
    netPnL: "Netto-G&V",
    byTradingSymbol: "Nach Trading-Symbol",
    byTimeOfDay: "Nach Tageszeit",
    noData: "Keine Handelsdaten verfügbar"
  },
  riskAnalysis: {
    title: "Risikoanalyse",
    subtitle: "Konto-Risikometriken"
  },
  tradeHistory: {
    title: "Trade-Historie",
    tradesFound: "Trades gefunden",
    export: "Exportieren",
    allTrades: "Alle Trades",
    winsOnly: "Nur Gewinne",
    lossesOnly: "Nur Verluste",
    searchPlaceholder: "Nach Symbol suchen...",
    symbol: "Symbol",
    type: "Typ",
    entry: "Einstieg",
    exit: "Ausstieg",
    qty: "Menge",
    pnl: "P&L",
    duration: "Dauer",
    entryDateTime: "Einstiegsdatum/-zeit",
    exitDateTime: "Ausstiegsdatum/-zeit",
    showing: "Zeige",
    of: "von",
    trades: "Trades",
    previous: "Zurück",
    next: "Weiter",
    winningTrades: "Gewinn-Trades",
    losingTrades: "Verlust-Trades",
    totalPnL: "Gesamt G&V",
    winRate: "Gewinnrate",
    noTradesFound: "Keine Trades gefunden"
  },
  tradingStatistics: {
    title: "Trading-Statistiken",
    subtitle: "Detaillierte Performance-Metriken",
    winRate: "Gewinnrate",
    winningTrades: "Gewinn-Trades",
    losingTrades: "Verlust-Trades",
    averagePerformance: "Durchschnittliche Performance",
    avgWin: "Durchschn. Gewinn",
    avgLoss: "Durchschn. Verlust",
    profitFactor: "Profit-Faktor",
    extremes: "Extreme",
    largestWin: "Größter Gewinn",
    largestLoss: "Größter Verlust",
    bestDay: "Bester Tag",
    worstDay: "Schlechtester Tag",
    streaks: "Serien",
    maxWinningStreak: "Max. Gewinnserie",
    maxLosingStreak: "Max. Verlustserie",
    avgTradeDuration: "Durchschn. Trade-Dauer",
    trades: "Trades"
  },
  affiliate: {
    title: "Affiliate-Programm",
    referralSystem: "Empfehlungssystem",
    earnCommissions: "Verdienen Sie Provisionen durch Empfehlungen",
    tier: "Stufe",
    silver: "Silber",
    gold: "Gold",
    bonus: "Bonus",
    handleChangedToast: "Ihr Affiliate-Handle wurde geaendert. Ihre Referral-Links wurden automatisch aktualisiert. Bitte pruefen Sie, ob bereits geteilte Marketing-Links ausgetauscht werden muessen.",
    errorTitle: "Affiliate-Daten konnten nicht geladen werden",
    errorSubtitle: "Etwas ist schiefgelaufen",
    errorDescription: "Wir konnten Ihre Affiliate-Informationen nicht laden. Dies kann passieren, wenn Ihr Affiliate-Konto noch nicht eingerichtet wurde oder ein voruebergehendes Verbindungsproblem aufgetreten ist.",
    retry: "Erneut versuchen",
    backToDashboard: "Zurueck zum Dashboard",
    createAffiliate: "Affiliate erstellen",
    creating: "Wird erstellt...",
    enrollFailed: "Affiliate-Konto konnte nicht erstellt werden. Bitte versuchen Sie es erneut."
  },
  affiliateOverview: {
    totalEarnings: "Gesamteinnahmen",
    activeReferrals: "Aktive Empfehlungen",
    conversionRate: "Konversionsrate",
    totalCommissions: "Gesamtprovisionen",
    commissionRate: "Provisionsrate",
    thisMonth: "diesen Monat",
    standard: "Standard",
    onAllSales: "auf alle Verkäufe",
    vsLastMonth: "vs letzten Monat"
  },
  affiliateTier: {
    tier: "Stufe",
    progressTo: "Fortschritt zu",
    currentAffiliate: "Aktuelle Affiliate-Stufe",
    currentBenefits: "Aktuelle Vorteile",
    progressToTier: "Fortschritt zu Stufe",
    current: "Aktuell",
    allAffiliateTiers: "Alle Affiliate-Stufen",
    revenue: "Umsatz",
    nextTierUnlock: "Nächste Stufe freischalten",
    moreRevenueNeeded: "mehr Umsatz benötigt",
    achieved: "Erreicht"
  },
  affiliateStatistics: {
    title: "Affiliate-Statistiken",
    weeklyEarningsOverview: "Wöchentliche Einnahmen-Übersicht",
    day: "Tag",
    week: "Woche",
    month: "Monat",
    year: "Jahr",
    currentMonth: "Aktueller Monat",
    currentQuarter: "Aktuelles Quartal",
    currentYear: "Aktuelles Jahr",
    last5Years: "Letzte 5 Jahre",
    previousMonth: "Vorheriger Monat",
    previousQuarter: "Vorheriges Quartal",
    previousYear: "Vorheriges Jahr",
    nextMonth: "Nächster Monat",
    nextQuarter: "Nächstes Quartal",
    nextYear: "Nächstes Jahr",
    monthsAgo: "Monate zurück",
    monthsAhead: "Monate voraus",
    quartersAgo: "Quartale zurück",
    quartersAhead: "Quartale voraus",
    yearsAgo: "Jahre zurück",
    yearsAhead: "Jahre voraus",
    totalEarningsLabel: "Gesamteinnahmen",
    lastWeeks: "letzte 12 Wochen",
    bestDayLabel: "Bester Tag",
    bestWeekLabel: "Beste Woche",
    bestMonthLabel: "Bester Monat",
    bestYearLabel: "Bestes Jahr",
    bestWeek: "Beste Woche",
    noData: "Keine Daten",
    referrals: "Empfehlungen",
    avg: "Ø",
    hoverForDetails: "Datenpunkte im Diagramm hovern für Details"
  },
  commissionTracking: {
    title: "Provisions-Tracking",
    found: "Provisionen gefunden",
    all: "Alle",
    paid: "Bezahlt",
    pending: "Ausstehend",
    posted: "Gebucht",
    canceled: "Storniert",
    searchPlaceholder: "Provisionen suchen...",
    commissionId: "Provisions-ID",
    customer: "Kunde",
    plan: "Plan",
    commission: "Provision",
    status: "Status",
    source: "Quelle",
    purchaseDate: "Kaufdatum",
    paidDate: "Bezahldatum",
    rate: "Rate",
    showing: "Zeige",
    of: "von",
    commissions: "Provisionen",
    previous: "Zurück",
    next: "Weiter",
    totalCommission: "Gesamtprovision",
    avgCommission: "Ø Provision",
    onHoldUntil: "Zurückgestellt bis",
    postedAt: "Gebucht am",
    canceledAt: "Storniert am",
    reason: "Grund",
    sourceDetails: "Quellen-Details",
    category: "Kategorie",
    code: "Code",
    path: "Pfad",
    noCommissions: "Keine Provisionen gefunden",
    noCommissionsDescription: "Es gibt keine Provisionseinträge, die Ihren Filtern entsprechen"
  },
  earningsOverview: {
    title: "Einnahmen-Übersicht",
    subtitle: "Ihre Affiliate-Performance",
    month: "Monat",
    quarter: "Quartal",
    year: "Jahr",
    totalEarnings: "Gesamteinnahmen",
    pending: "Davon ausstehend",
    performanceMetrics: "Performance-Metriken",
    conversionRate: "Konversionsrate",
    avgCommission: "Durchschn. Provision",
    transactions: "Transaktionen",
    totalClicks: "Gesamt-Klicks",
    totalConversions: "Gesamt-Konversionen",
    monthlyProgress: "Monatlicher Fortschritt",
    quarterlyProgress: "Quartals-Fortschritt",
    yearlyProgress: "Jahres-Fortschritt",
    allTimeProgress: "Gesamt-Fortschritt",
    goalProgress: "Ziel-Fortschritt",
    goal: "Ziel",
    all: "Gesamt"
  },
  marketingMaterials: {
    title: "Marketing-Materialien",
    subtitle: "Professionelle Assets für die Promotion",
    banners: "Banner",
    content: "Inhalte",
    logos: "Logos",
    availableAssets: "Verfügbare Assets",
    quality: "Qualität",
    preview: "Vorschau"
  },
  partnerLandingPage: {
    title: "Partner-Landing-Page",
    subtitle: "Ihre benutzerdefinierte Empfehlungsseite",
    landingPageUrl: "Landing-Page-URL",
    copyLink: "Link kopieren",
    partnerName: "Partner-Name",
    editText: "Text bearbeiten",
    enterPartnerName: "Partner-Namen eingeben",
    cancel: "Abbrechen",
    save: "Speichern",
    saving: "Speichert...",
    landingPageStats: "Landing-Page-Statistiken",
    totalVisits: "Gesamt-Besuche",
    conversions: "Konversionen",
    conversionRate: "Konversionsrate",
    revenue: "Umsatz",
    commission: "Provision"
  },
  payoutReports: {
    title: "Auszahlungsberichte",
    subtitle: "Monatliche Provisionsberichte & Wallet-Auszahlungen",
    all: "Alle",
    paid: "Bezahlt",
    pending: "Ausstehend",
    completed: "Abgeschlossen",
    rejected: "Abgelehnt",
    canceled: "Storniert",
    totalPaid: "Gesamt bezahlt",
    totalReferrals: "Gesamt-Empfehlungen",
    reports: "Berichte",
    referrals: "Empfehlungen",
    paidToWallet: "An Wallet bezahlt",
    paidOn: "Bezahlt am",
    pendingTooltip: "Wird am Ende des Monats ausgezahlt",
    walletPendingTooltip: "Auszahlungsanfrage wird bearbeitet",
    walletCompletedTooltip: "Auszahlung wurde abgeschlossen",
    walletRejectedTooltip: "Auszahlung wurde abgelehnt",
    walletCanceledTooltip: "Auszahlung wurde storniert",
    rejectionReason: "Grund",
    walletPayout: "Affiliate Wallet-Auszahlung",
    settlementReport: "Provisionsabrechnung",
    noReceiptAvailable: "Kein Beleg für diese Auszahlung verfügbar",
    showing: "Zeige",
    of: "von",
    nextPayout: "Nächste Auszahlung",
    exportAllReports: "Alle Berichte exportieren",
    noFileAvailable: "Keine Datei für diese Abrechnung verfügbar",
    downloadFailed: "Download fehlgeschlagen. Bitte versuchen Sie es erneut.",
    noReports: "Noch keine Auszahlungsberichte vorhanden",
    adjustFilters: "Versuche deine Filter anzupassen"
  },
  referralLinks: {
    title: "Empfehlungslinks & Codes",
    subtitle: "Verwalten Sie Ihre Empfehlungslinks und Codes",
    tabLinks: "Links",
    tabCodes: "Codes",
    createCustomReferralLink: "Empfehlungslink erstellen",
    createCustomReferralCode: "Empfehlungscode erstellen",
    linkName: "Link-Name",
    codeName: "Code-Name",
    linkNamePlaceholder: "z.B. YouTube Special",
    codeNamePlaceholder: "z.B. YOUTUBE2025",
    description: "Beschreibung",
    descriptionPlaceholder: "z.B. Spezieller Link für YouTube-Inhalte",
    codeDescriptionPlaceholder: "z.B. Spezieller Code für YouTube-Zuschauer",
    category: "Kategorie",
    categoryPlaceholder: "z.B. YouTube, Instagram, etc.",
    customSlug: "Benutzerdefinierter Slug (Optional)",
    customSlugPlaceholder: "deine-url",
    customCode: "Benutzerdefinierter Code",
    customCodePlaceholder: "MEINCODE2025",
    leaveEmptyNote: "Leer lassen für automatische Generierung",
    leaveEmptyCodeNote: "Leer lassen für automatische Code-Generierung",
    cancel: "Abbrechen",
    createLink: "Link erstellen",
    createCode: "Code erstellen",
    clicks: "Klicks",
    uses: "Verwendungen",
    conversions: "Konversionen",
    rate: "Rate",
    showing: "Zeige",
    of: "von",
    links: "Links",
    codes: "Codes",
    previous: "Zurück",
    next: "Weiter",
    page: "Seite",
    createCustomLink: "Link erstellen",
    createCustomCode: "Code erstellen",
    noLinks: "Noch keine Empfehlungslinks vorhanden",
    noCodes: "Noch keine Empfehlungscodes vorhanden",
    defaultCodeName: "Standard",
    defaultCodeCategory: "Global",
    defaultCodeDescription: "Systemgenerierter Code mit 10% Rabatt"
  },
  trafficSources: {
    title: "Traffic-Quellen",
    subtitle: "Woher Ihr Traffic kommt",
    clicks: "Klicks",
    rate: "Rate",
    uses: "Verwendungen",
    transactions: "Transaktionen",
    noLinksYet: "Noch keine Link-Traffic-Quellen verfügbar",
    noCodesYet: "Noch keine Code-Traffic-Quellen verfügbar",
    showing: "Zeige",
    of: "von",
    sources: "Quellen",
    previous: "Zurück",
    next: "Weiter",
    summary: "Zusammenfassung",
    totalClicks: "Gesamt-Klicks",
    totalUses: "Gesamt-Verwendungen",
    conversions: "Konversionen",
    totalCommission: "Gesamt-Provision",
    avgRate: "Durchschn. Rate"
  },
  walletModal: {
    title: "Wallet",
    subtitle: "Verwalten Sie Ihre Gelder",
    overview: "Übersicht",
    transactions: "Transaktionen"
  },
  walletBalance: {
    title: "Wallet-Guthaben",
    available: "Verfügbare Mittel",
    today: "heute"
  },
  balanceBreakdown: {
    title: "Guthaben-Aufschlüsselung",
    affiliateCommissions: "Affiliate-Provisionen",
    affiliateDesc: "Einnahmen aus Empfehlungen",
    rewards: "Belohnungen",
    rewardsDesc: "Bonus-Verdienste",
    crediting: "Gutschriften",
    creditingDesc: "Konto-Gutschriften",
    processing: "Verarbeitung...",
    payout: "Auszahlung",
    creditsNote: "Gutschriften und Belohnungen werden automatisch zu Ihrem Guthaben hinzugefügt und können für alle Käufe verwendet aber nicht ausgezahlt werden werden."
  },
  transactionHistory: {
    title: "Transaktionshistorie",
    recentActivity: "Letzte Aktivität",
    viewAll: "Alle anzeigen",
    showing: "Zeige",
    of: "von",
    transactions: "Transaktionen"
  },
  payoutTab: {
    availableForPayout: "Verfügbar für Auszahlung",
    affiliateCommissionBalance: "Affiliate-Provisions-Guthaben",
    bankTransfer: "Banküberweisung",
    paypal: "PayPal",
    cryptocurrency: "Kryptowährung",
    requestAffiliatePayout: "Affiliate-Auszahlung anfordern",
    withdrawCommissionEarnings: "Ihre Provisionseinnahmen abheben",
    selectPaymentMethod: "Zahlungsmethode auswählen",
    payoutSummary: "Auszahlungs-Zusammenfassung",
    requestedAmount: "Angeforderter Betrag",
    processingFee: "Bearbeitungsgebühr",
    netAmount: "Nettobetrag",
    processingRequest: "Anfrage wird bearbeitet...",
    importantNotes: "Wichtige Hinweise",
    note1: "Affiliate-Auszahlungen werden innerhalb von 1-2 Werktagen bearbeitet",
    note2: "Mindestauszahlungsbetrag ist €50 für alle Zahlungsmethoden",
    note3: "Bearbeitungsgebühren variieren je nach Zahlungsmethode",
    payoutRequestSubmitted: "Auszahlungsanfrage eingereicht!",
    payoutRequestSuccess: "Ihre Auszahlungsanfrage über ${amount} wurde erfolgreich eingereicht.",
    affiliateCommissions: "Affiliate-Provisionen",
    readyForWithdrawal: "Bereit zur Auszahlung",
    bankTransferDesc: "Direktüberweisung auf Ihr Bankkonto",
    free: "Kostenlos",
    paypalDesc: "Schnelle Auszahlung über PayPal",
    cryptocurrencyDesc: "Auszahlung per Kryptowährung",
    account: "Konto",
    amount: "Betrag",
    method: "Methode",
    destination: "Ziel",
    processingTime: "Bearbeitungszeit",
    businessDays: "1-3 Werktage",
    fee: "Gebühr",
    managePayouts: "Methoden verwalten"
  },
  payouts: {
    title: "Auszahlungen",
    management: "Auszahlungs-Management",
    description: "Auszahlungen anfordern und verfolgen",
    available: "Verfügbar"
  },
  payoutStats: {
    availableBalance: "Verfügbares Guthaben",
    totalPaidOut: "Gesamt ausgezahlt",
    thisMonth: "Diesen Monat",
    nextPayout: "Nächste Auszahlung",
    pendingPayouts: "Ausstehende Auszahlungen",
    pending: "Ausstehend",
    today: "Heute",
    payouts: "Auszahlungen",
    allTime: "Alle Zeit",
    january2025: "Januar 2025",
    tomorrow: "Morgen",
    dailySchedule: "Täglicher Zeitplan",
    automatic: "Automatisch"
  },
  payoutRequest: {
    title: "Auszahlung anfordern",
    subtitle: "Ihre Trading-Gewinne abheben",
    selectAccount: "Konto auswählen",
    availableBalance: "Verfügbares Guthaben",
    payoutAmount: "Auszahlungsbetrag",
    minAmount: "Mindestbetrag",
    amountError: "Betrag muss zwischen {min} und {max} liegen",
    insufficientBalance: "Ihre verfügbare Balance liegt unter der Mindestauszahlungssumme von {min}",
    selectAccountFirst: "Bitte wählen Sie zuerst ein Konto aus",
    paymentMethod: "Zahlungsmethode",
    selectYour: "Wählen Sie Ihre",
    bankTransfer: "Banküberweisung",
    paypal: "PayPal",
    crypto: "Kryptowährung",
    ach: "ACH-Überweisung",
    bankTransferDesc: "Banküberweisung (1-3 Werktage)",
    paypalDesc: "PayPal-Überweisung (sofort)",
    cryptoDesc: "Kryptowährungs-Überweisung (sofort)",
    achDesc: "Banküberweisung per ACH (1-3 Werktage)",
    fee: "Gebühr",
    free: "Kostenlos",
    payoutSummary: "Auszahlungs-Zusammenfassung",
    requestedAmount: "Angeforderter Betrag",
    processingFee: "Bearbeitungsgebühr",
    netAmount: "Nettobetrag",
    submitRequest: "Auszahlungsanfrage einreichen",
    processing: "Verarbeitung...",
    importantNotes: "Wichtige Hinweise",
    note1: "Auszahlungen werden innerhalb von 1-3 Werktagen bearbeitet",
    note2: "Mindestauszahlungsbetrag ist $50",
    note3: "Sie können nur Auszahlungen von finanzierten Konten anfordern",
    available: "Verfügbar",
    payoutRequestSubmitted: "Auszahlungsanfrage eingereicht!",
    payoutRequestSuccess: "Ihre Auszahlungsanfrage über ${amount} wurde erfolgreich eingereicht.",
    account: "Konto",
    amount: "Betrag",
    method: "Methode",
    destination: "Ziel",
    processingTime: "Bearbeitungszeit",
    businessDays: "1-3 Werktage",
    noFundedAccountsTitle: "Keine finanzierten Konten verfügbar",
    noFundedAccountsDesc: "Sie haben derzeit keine finanzierten Konten mit verfügbarem Guthaben für eine Auszahlung.",
    noAffiliateBalanceTitle: "Kein Affiliate-Guthaben verfügbar",
    noAffiliateBalanceDesc: "Sie haben derzeit kein Affiliate-Provisionsguthaben für eine Auszahlung.",
    selectCurrency: "Währung auswählen",
    currency: "Währung",
    noMethodsConfigured: "Keine {method}-Methoden konfiguriert. Bitte fügen Sie eine unter Zahlungsmethoden hinzu.",
    kycNotVerifiedTitle: "KYC-Verifizierung erforderlich",
    kycNotVerifiedDesc: "Ihre Identität wurde noch nicht verifiziert. Bitte schließen Sie die KYC-Verifizierung ab, um eine Auszahlung anfordern zu können.",
    verifyKycNow: "Jetzt verifizieren"
  },

  payoutEligibility: {
    title: "Auszahlungsberechtigung",
    loading: "Auszahlungsberechtigung wird geprüft...",
    error: "Berechtigung konnte nicht geprüft werden. Bitte versuchen Sie es später erneut.",
    eligible: "Sie sind für eine Auszahlung berechtigt",
    notEligible: "Sie sind noch nicht für eine Auszahlung berechtigt",
    rules: "Regeln",
    passed: "bestanden",
    checkPassed: "Bestanden",
    checkFailed: "Nicht bestanden",
    required: "Erforderlich",
    actual: "Aktuell",
    maxPayout: "Max. Auszahlungsbetrag",
  },
  payoutMethods: {
    title: "Zahlungsmethoden",
    subtitle: "Verwaltung",
    add: "Neu",
    paypal: "PayPal",
    default: "Standard",
    setDefault: "Standard",
    addPaymentMethod: "Neu",
    bankTransfer: "Banküberweisung",
    bankTransferDesc: "Direkte Banküberweisung",
    paypalDesc: "PayPal-Zahlungen",
    crypto: "Kryptowährung",
    cryptoDesc: "Krypto-Zahlungen",
    ach: "ACH-Überweisung",
    achDesc: "Direkte Banküberweisung per ACH",
    accountHolder: "Kontoinhaber",
    iban: "IBAN",
    bicSwift: "BIC/SWIFT",
    bankName: "Bank Name",
    routingNumber: "Bankleitzahl",
    accountNumber: "Kontonummer",
    enterRoutingNumber: "Bankleitzahl eingeben",
    enterAccountNumber: "Kontonummer eingeben",
    paypalEmail: "PayPal-E-Mail",
    walletAddress: "Wallet-Adresse",
    currencyType: "Währungstyp",
    accountCurrency: "Kontowährung",
    paypalCurrency: "PayPal-Währung",
    enterAccountHolder: "Kontoinhaber-Namen eingeben",
    enterIban: "IBAN eingeben",
    enterBicSwift: "BIC/SWIFT-Code eingeben",
    enterBankName: "Bankname eingeben",
    enterPaypalEmail: "PayPal-E-Mail eingeben",
    enterWalletAddress: "Wallet-Adresse eingeben",
    enterCurrencyType: "Währungstyp eingeben",
    cancel: "Abbrechen",
    saveMethod: "Methode speichern",
    secureEncrypted: "Sicher & Verschlüsselt",
    securityNote: "Alle Zahlungsinformationen werden verschlüsselt und sicher gespeichert. Wir speichern niemals sensible Zahlungsdetails."
  },
  payoutHistory: {
    title: "Auszahlungshistorie",
    payoutsFound: "Auszahlungen gefunden",
    export: "Exportieren",
    allPayouts: "Alle Auszahlungen",
    completed: "Abgeschlossen",
    processing: "In Bearbeitung",
    failed: "Fehlgeschlagen",
    searchPlaceholder: "Auszahlungen suchen...",
    payoutId: "Auszahlungs-ID",
    amount: "Betrag",
    method: "Methode",
    status: "Status",
    requestDateTime: "Anfragedatum/-zeit",
    completedDateTime: "Abschlussdatum/-zeit",
    account: "Konto",
    reference: "Referenz",
    action: "Aktion",
    fee: "Gebühr",
    net: "Netto",
    pending: "Ausstehend",
    cancelPayout: "Auszahlung stornieren",
    showing: "Zeige",
    of: "von",
    payouts: "Auszahlungen",
    previous: "Zurück",
    next: "Weiter",
    totalNet: "Gesamt-Netto",
    statusPending: "Ausstehend",
    statusCanceled: "Storniert",
    statusCompleted: "Abgeschlossen",
    canceledByUser: "Vom Benutzer storniert",
    noReasonProvided: "Kein Grund angegeben",
    noPayoutsFound: "Keine Auszahlungen gefunden",
    noPayoutsMessage: "Es gibt keine Auszahlungen, die Ihren Filtern entsprechen",
    loading: "Auszahlungen werden geladen...",
    pleaseWait: "Bitte warten..."
  },
  support: {
    title: "Support-Center",
    subtitle: "Wir sind hier, um dir zu helfen",
    premiumSupport: "Premium Support",
    helpAndFaq: "Hilfe & FAQ",
    helpAndSupport: "Hilfe & Support",
    getHelpWhenNeeded: "Hilfe erhalten, wenn Sie sie brauchen",
    available247: "24/7 verfügbar",
    maintenanceTitle: "Support-Bereich im Aufbau",
    maintenanceMessage: "Wir aktivieren und finalisieren gerade den neuen Support-Bereich. In der Zwischenzeit wende dich bei allen Fragen bitte wie gewohnt per E-Mail an uns:",
    maintenanceEmail: "support@nextproptrader.com",
    contactUs: "Kontaktiere uns",
    emailDescription: "Sende uns eine E-Mail und unser Support-Team wird sich so schnell wie möglich bei dir melden.",
    clickToEmail: "Klicken zum E-Mail senden",
    responseTime: "Typische Antwortzeit innerhalb von 24 Stunden"
  },
  supportStats: {
    responseTime: "Antwortzeit",
    resolutionRate: "Lösungsrate",
    activeTickets: "Aktive Tickets",
    satisfaction: "Zufriedenheit",
    average: "Durchschnitt",
    businessHours: "Geschäftszeiten",
    firstContact: "Erster Kontakt",
    resolution: "Lösung",
    vsYesterday: "vs gestern",
    thisMonth: "diesen Monat"
  },
  supportTickets: {
    title: "Support-Tickets",
    subtitle: "Verfolge und verwalte deine Tickets",
    loading: "Tickets werden geladen...",
    ticketsFound: "Tickets gefunden",
    noTicketsFound: "Keine Tickets gefunden",
    adjustFilters: "Versuche deine Filter oder den Suchbegriff anzupassen",
    createdLabel: "Erstellt:",
    updatedLabel: "Aktualisiert:",
    all: "Alle",
    open: "Offen",
    closed: "Geschlossen",
    resolved: "Gelöst",
    status_open: "OFFEN",
    status_pending: "AUSSTEHEND",
    status_in_progress: "IN BEARBEITUNG",
    status_resolved: "GELÖST",
    status_closed: "GESCHLOSSEN",
    priority_low: "NIEDRIG",
    priority_medium: "MITTEL",
    priority_high: "HOCH",
    priority_urgent: "DRINGEND",
    searchPlaceholder: "Tickets suchen...",
    ticketId: "Ticket-ID",
    subject: "Betreff",
    status: "Status",
    priority: "Priorität",
    created: "Erstellt",
    assignedTo: "Zugewiesen an",
    ticketDetails: "Ticket-Details",
    category: "Kategorie",
    lastUpdate: "Letztes Update",
    conversation: "Unterhaltung",
    messages: "Nachrichten",
    typeMessage: "Ihre Nachricht eingeben...",
    sendMessage: "Nachricht senden",
    sending: "Senden...",
    ticketResolved: "Dieses Ticket wurde gelöst",
    noMoreMessages: "Keine weiteren Nachrichten können gesendet werden",
    closingTicket: "Ticket wird geschlossen...",
    closeTicket: "Ticket schließen",
    showing: "Zeige",
    of: "von",
    tickets: "Tickets",
    previous: "Zurück",
    next: "Weiter",
    noMessages: "Noch keine Nachrichten",
    you: "Du",
    supportTeam: "Support-Team",
    attachment: "Anhang",
    attachFile: "Datei anhängen",
    attachments: "Anhänge",
    uploading: "Wird hochgeladen...",
    uploadFailed: "Upload fehlgeschlagen",
    uploadingAttachments: "Anhänge werden hochgeladen...",
    fileTooLarge: "Datei zu groß (max. 10 MB)",
    invalidFileType: "Ungültiger Dateityp",
    allowedTypes: "Erlaubt: jpg, png, gif, pdf, doc, docx, txt, zip, rar",
    downloadAttachment: "Herunterladen",
    removeAttachment: "Entfernen"
  },

  knowledgeBase: {
    title: "Wissensdatenbank",
    subtitle: "Schnell Antworten finden",
    searchPlaceholder: "Artikel suchen...",
    allArticles: "Alle Artikel",
    gettingStarted: "Erste Schritte",
    platformGuide: "Plattform-Leitfaden",
    evaluationProcess: "Evaluierungsprozess",
    payoutsBilling: "Auszahlungen & Abrechnung",
    troubleshooting: "Fehlerbehebung",
    popular: "BELIEBT",
    readTime: "Lesezeit",
    views: "Aufrufe",
    updatedLabel: "Aktualisiert:",
    noArticlesFound: "Keine Artikel gefunden",
    adjustSearch: "Versuche deinen Suchbegriff oder die Kategorie anzupassen",
    articlesFound: "Artikel gefunden",
    viewAll: "Alle anzeigen"
  },
  liveChat: {
    title: "Support",
    subtitle: "Erstelle ein Ticket",
    available247: "24/7 verfügbar",
    initialBotMessage: "Hallo! Ich bin hier, um Ihnen bei Fragen oder Problemen zu helfen. Wie kann ich Ihnen heute helfen?",
    supportAvailable: "Support verfügbar",
    averageResponse: "Durchschnittliche Antwort: < 2 Stunden",
    newTicket: "Neues Ticket",
    quickHelpTopics: "Schnelle Hilfe-Themen",
    accountLoginIssues: "Konto- & Login-Probleme",
    platformTechnicalSupport: "Plattform- & technischer Support",
    payoutQuestions: "Auszahlungsfragen",
    evaluationProcessHelp: "Hilfe zum Evaluierungsprozess",
    priority: "Priorität",
    responseTimes: "Antwortzeiten",
    highPriorityText: "Hohe Priorität",
    mediumPriorityText: "Mittlere Priorität",
    lowPriorityText: "Niedrige Priorität",
    supportTeam: "Support-Team",
    available: "Verfügbar",
    ticketSubject: "Ticket-Betreff",
    describeIssue: "Beschreiben Sie Ihr Problem...",
    ticketCreated: "Ticket erstellt",
    closeTicket: "Ticket schließen",
    ticketCreatedSuccess: "Vielen Dank, dass Sie den Support kontaktiert haben! Ihr Ticket wurde mit der ID erstellt: {{ticketId}}. Unser Team wird Ihre Anfrage prüfen und innerhalb einiger Stunden während der Geschäftszeiten antworten.",
    ticketCreationError: "Entschuldigung, beim Erstellen Ihres Tickets ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support direkt.",
    responses: {
      concern: "Ich verstehe Ihre Sorge. Lassen Sie mich das für Sie prüfen.",
      escalate: "Vielen Dank für die zusätzlichen Informationen. Ich werde dies an unser technisches Team weiterleiten.",
      question: "Das ist eine großartige Frage! Lassen Sie mich Ihnen die Details geben.",
      noted: "Ich habe dies in Ihrem Ticket vermerkt. Unser Team wird weiter untersuchen.",
      anything: "Gibt es noch etwas, bei dem ich Ihnen zu diesem Problem helfen kann?"
    },
    whatHappensNext: "Was passiert als Nächstes?",
    whatHappensNextDescription: "Unser Support-Team wird Ihr Ticket prüfen und innerhalb der erwarteten Zeitrahmen basierend auf Ihrer Prioritätsstufe antworten. Sie erhalten Updates per E-Mail.",
    createAnotherTicket: "Weiteres Ticket erstellen",
    ticketIdLabel: "Ticket-ID",
    statusLabel: "Status",
    statusOpen: "OFFEN",
    creatingTicket: "Ticket wird erstellt...",
    categoryLabel: "Kategorie",
    categories: {
      general: "Allgemein",
      account: "Konto",
      technical: "Technisch",
      payout: "Auszahlung",
      evaluation: "Evaluierung"
    }
  },
  faqSection: {
    badge: "Häufig gestellte Fragen",
    title: "Alles, was du",
    titleHighlight: "wissen musst",
    subtitle: "Antworten auf die wichtigsten Fragen rund um unser Prop-Trading-Programm.",
    questions: {
      q1: {
        question: "Wie funktioniert der 100% Profit Split?",
        answer: "Du behältst 100% der Gewinne, die du auf deinem Funded-Konto erzielst. Wir nehmen keinen Anteil, weil unser Geschäftsmodell anders funktioniert: Wenn du profitabel tradest, replizieren wir deine Trades im Hintergrund mit größeren Positionsgrößen. Dein Erfolg ist unser Erfolg – deshalb investieren wir in deine langfristige Performance, nicht in den Verkauf von Evaluierungen."
      },
      q2: {
        question: "Welche Regeln gelten während der Evaluierung?",
        answer: "Es gibt 4 einfache Regeln: (1) Du brauchst mindestens 5 Handelstage, um die Evaluierung zu bestehen – es gibt kein Maximum an Handelstagen. (2) Überschreite nicht die maximale Lot-Größe deines Kontos. (3) Bleibe über dem Trailing-Drawdown-Limit. (4) Schließe alle Positionen bis spätestens 15:15 Uhr CST – der Handel wird um 17:00 Uhr CST wieder aufgenommen. Das Gewinnziel liegt je nach Kontogröße bei 6-8%."
      },
      q3: {
        question: "Was ist die Lucky Punch Rule und der Scaling Plan?",
        answer: "Im Funded-Konto gelten nur 2 Regeln. Die Lucky Punch Rule: Kein einzelner Trade darf mehr als 30% deines gesamten P&L ausmachen – das stellt konsistente Performance sicher. Der Scaling Plan: Du startest mit 1 Kontrakt und schaltest pro $2.500 Gewinn einen weiteren Kontrakt frei. Nach $2.500 Gewinn kannst du 2 Kontrakte traden, nach $5.000 werden 3 freigeschaltet, und so weiter."
      },
      q4: {
        question: "Wie schnell werde ich funded und wie funktionieren Auszahlungen?",
        answer: "Die Evaluierung kannst du in nur 5 Handelstagen bestehen. Nach bestandener Prüfung wird dein Funded-Konto in der Regel innerhalb von 24 Stunden an Werktagen aktiviert. Auszahlungen kannst du täglich beantragen – per Banküberweisung, PayPal oder Kryptowährung. Der Mindestbetrag liegt bei $50, die Bearbeitungszeit beträgt 1-3 Werktage."
      },
      q5: {
        question: "Welche Datenfeeds und Plattformen nutzt ihr?",
        answer: "Wir verwenden Datenfeeds von Rithmic und DXFeed mit Echtzeit-Level-2-Marktdaten und Sub-Millisekunden-Ausführung. Es werden alle Plattformen unterstützt, die eine Rithmic- oder DXFeed-Verbindung aufbauen können. Alle Konten beinhalten Non-Professional CME-Marktdaten ohne Zusatzkosten."
      },
      q6: {
        question: "Was ist der Trailing Drawdown und wie funktioniert er?",
        answer: "Der Trailing Drawdown ist ein dynamisches maximales Verlustlimit, das sich nach oben bewegt, wenn dein Konto neue Höchststände erreicht. Beispiel: Startet dein Konto bei $50.000 mit $2.500 Trailing Drawdown, liegt deine Untergrenze bei $47.500. Steigt dein Kontostand auf $52.000, verschiebt sich die Untergrenze auf $49.500. Der Drawdown folgt immer deinem höchsten Kontostand."
      },
      q7: {
        question: "Wie viele Konten kann ich gleichzeitig traden?",
        answer: "Es gibt kein Limit. Du kannst so viele Konten gleichzeitig traden, wie du möchtest. Ob du lieber ein Konto oder mehrere gleichzeitig verwaltest, liegt ganz bei dir."
      },
      q8: {
        question: "Was passiert, wenn ich die Evaluation nicht bestehe oder es zeitlich nicht schaffe?",
        answer: "Bei Evaluierungskonten kannst du dein Konto gegen eine Gebühr zurücksetzen und von vorne beginnen. Du kannst dein Konto auch jederzeit verlängern, um mehr Zeit zu bekommen. Bei Funded-Konten musst du eine neue Evaluation bestehen, wenn du die Regeln verletzt. Sowohl Evaluierungs- als auch Funded-Konten können jederzeit verlängert werden."
      },
      q9: {
        question: "Gibt es eine Funded Fee für Funded-Konten?",
        answer: "Ja, sobald du ein Funded-Konto hast, fällt eine monatliche Funded Fee von 95 € an. Diese Gebühr deckt sämtliche Software- und Datenkosten ab, einschließlich Echtzeit-Marktdaten und technischer Infrastruktur. Das Besondere: Die 95 € gelten für ALLE deine Funded-Konten zusammen — egal ob du 1 oder 10 Konten hast, du zahlst immer nur einmal 95 € pro Monat. Die Gebühr wird erst fällig, wenn du die Evaluierung erfolgreich bestanden hast."
      }
    },
    titleDashboard: "Häufig Gestellte Fragen",
    subtitleDashboard: "Finde Antworten auf häufige Fragen",
    allCategories: "Alle Kategorien",
    general: "Allgemein",
    trading: "Trading",
    gettingStarted: "Erste Schritte",
    evaluation: "Evaluierung",
    platform: "Plattform",
    payouts: "Auszahlungen",
    account: "Konto",
    rules: "Regeln",
    articlesFound: "Artikel gefunden",
    searchPlaceholder: "Artikel suchen...",
    howToStartEvaluation: "Wie starte ich eine Evaluierung?",
    howToStartEvaluationAnswer: "Wähle deine Kontogröße ($10K-$250K) auf der Preisseite und schließe den Kauf ab. Dein Evaluierungskonto wird automatisch eingerichtet und du kannst sofort mit dem Trading beginnen. Die Mindest-Evaluierungsdauer beträgt 5 Handelstage.",
    whatIsProfitTarget: "Was ist das Gewinnziel?",
    whatIsProfitTargetAnswer: "Das Gewinnziel liegt bei 6-8% deiner Kontogröße, abhängig vom gewählten Tier. Beispiel: Bei einem $50K-Konto mit 6% Ziel musst du $3.000 Gewinn erreichen. Es gibt kein Zeitlimit – nimm dir so lange, wie du brauchst.",
    howLongEvaluation: "Gibt es ein Zeitlimit für die Evaluierung?",
    howLongEvaluationAnswer: "Es gibt kein maximales Zeitlimit für den Abschluss deiner Evaluierung. Du brauchst mindestens 5 Handelstage, um zu bestehen. Du kannst dir so viele Tage nehmen, wie du brauchst, um das Gewinnziel zu erreichen und dabei die Regeln einzuhalten.",
    howToRequestPayout: "Wie beantrage ich eine Auszahlung?",
    howToRequestPayoutAnswer: "Gehe zum Wallet in deinem Dashboard und wähle den Auszahlungs-Tab. Wähle dein Funded-Konto, gib den Betrag ein (Minimum $50) und wähle deine bevorzugte Methode: Banküberweisung, PayPal oder Kryptowährung. Die Bearbeitung dauert 1-3 Werktage.",
    whatIsTrailingDrawdown: "Was ist der Trailing Drawdown?",
    whatIsTrailingDrawdownAnswer: "Der Trailing Drawdown ist ein dynamisches Verlustlimit, das sich nach oben bewegt, wenn dein Konto neue Höchststände erreicht. Wenn dein Konto bei $52.000 seinen Höchststand hat und der Drawdown $2.500 beträgt, liegt deine Untergrenze bei $49.500. Er bewegt sich nie zurück nach unten. Das stellt verantwortungsvolles Risikomanagement sicher.",
    canIUseEA: "Kann ich Expert Advisors (EAs) oder automatisierte Strategien nutzen?",
    canIUseEAAnswer: "Ja, EAs und automatisierte Strategien sind auf unserer Plattform erlaubt. Sie dürfen jedoch keine verbotenen Strategien verwenden wie Arbitrage, Hedging über mehrere Konten, Tick-Scalping oder jede Form von Latenz-Exploitation. Normale algorithmische Strategien sind willkommen.",
    whatTradingHours: "Was sind die Handelszeiten?",
    whatTradingHoursAnswer: "Alle Positionen müssen bis spätestens 15:15 Uhr CST geschlossen werden. Der Handel wird um 17:00 Uhr CST wieder aufgenommen. Dies gilt sowohl für Evaluierungs- als auch für Funded-Konten. Das Halten von Positionen über den Handelsschluss hinaus ist nicht erlaubt und kann zu einem Regelverstoß führen.",
    howToChangePassword: "Wie ändere ich mein Passwort oder Sicherheitseinstellungen?",
    howToChangePasswordAnswer: "Navigiere zu deiner Profilseite und öffne den Einstellungen-Tab. Unter dem Bereich Sicherheit kannst du dein Passwort ändern und die Zwei-Faktor-Authentifizierung für zusätzlichen Kontoschutz aktivieren.",
    whatDataFeeds: "Welche Datenfeeds und Marktdaten bietet ihr?",
    whatDataFeedsAnswer: "Wir nutzen Rithmic und DXFeed als Datenanbieter. Jedes Konto beinhaltet Echtzeit-Level-2-Marktdaten und Non-Professional CME-Daten ohne Zusatzkosten. Das garantiert präzise Preise mit Sub-Millisekunden-Ausführungsgeschwindigkeiten.",
    howToExtendAccount: "Kann ich mein Evaluierungskonto verlängern oder zurücksetzen?",
    howToExtendAccountAnswer: "Ja. Du kannst dein Konto um weitere 30 Tage verlängern oder es zurücksetzen, um neu zu starten – beides direkt über dein Dashboard. Durch unser Achievement- und Leveling-System kannst du auch kostenlose Resets und Verlängerungen freischalten.",
    whatIsLuckyPunch: "Was ist die Lucky Punch Rule?",
    whatIsLuckyPunchAnswer: "Die Lucky Punch Rule bedeutet, dass kein einzelner Trade mehr als 30% deines gesamten P&L auf einem Funded-Konto ausmachen darf. Beispiel: Bei einem Gesamtgewinn von $5.000 darf kein einzelner Trade mehr als $1.500 beigetragen haben. Das stellt konsistente Performance sicher, statt sich auf einen einzelnen Glückstrade zu verlassen.",
    whatIsScalingPlan: "Wie funktioniert der Scaling Plan?",
    whatIsScalingPlanAnswer: "Du startest mit 1 Kontrakt auf deinem Funded-Konto. Für je $2.500 kumulierten Gewinn schaltest du 1 weiteren Kontrakt frei. Nach $2.500 Gewinn kannst du 2 Kontrakte traden, nach $5.000 Gewinn 3 Kontrakte, und so weiter. So wächst deine Positionsgröße schrittweise mit deinem Konto.",
    whatPayoutMethods: "Welche Auszahlungsmethoden gibt es?",
    whatPayoutMethodsAnswer: "Wir bieten Banküberweisung, PayPal und Kryptowährung als Auszahlungsmethoden an. Der Mindestbetrag liegt bei $50. Die Bearbeitung dauert 1-3 Werktage. Du kannst täglich Auszahlungen über dein Dashboard-Wallet beantragen. Es gibt keine versteckten Gebühren.",
    whatAccountSizes: "Welche Kontogrößen gibt es?",
    whatAccountSizesAnswer: "Wir bieten Evaluierungskonten von $10.000 bis $250.000 Handelskapital. Jedes Konto-Tier hat sein eigenes Gewinnziel, maximale Lot-Größe und Trailing-Drawdown-Limit. Alle Konten beinhalten Level-2-Marktdaten, Non-Professional CME-Datenfeeds und 24/7 Support.",
    howManyAccounts: "Wie viele Konten kann ich gleichzeitig traden?",
    howManyAccountsAnswer: "Es gibt kein Limit. Du kannst so viele Konten gleichzeitig traden, wie du möchtest. Ob du lieber ein Konto oder mehrere gleichzeitig verwaltest, liegt ganz bei dir.",
    whatIfIFail: "Was passiert, wenn ich die Evaluation nicht bestehe oder es zeitlich nicht schaffe?",
    whatIfIFailAnswer: "Bei Evaluierungskonten kannst du dein Konto gegen eine Gebühr zurücksetzen und von vorne beginnen. Du kannst dein Konto auch jederzeit verlängern. Bei Funded-Konten musst du eine neue Evaluation bestehen, wenn du die Regeln verletzt. Sowohl Evaluierungs- als auch Funded-Konten können jederzeit verlängert werden.",
    priority: "Priorität",
    highPriorityText: "Hohe Priorität",
    mediumPriorityText: "Mittlere Priorität",
    lowPriorityText: "Niedrige Priorität",
    noResults: "Keine Artikel gefunden",
    tryDifferentSearch: "Versuche einen anderen Suchbegriff oder Filter.",
    contactTitle: "Noch Fragen?",
    contactDescription: "Unser Team hilft dir gerne weiter. Kontaktiere uns und wir melden uns schnellstmöglich.",
    contactButton: "Kontaktieren"
  },
  notifications: {
    title: "Benachrichtigungen",
    unread: "ungelesen",
    markAllRead: "Alle als gelesen markieren",
    noNotifications: "Keine Benachrichtigungen",
    allCaughtUp: "Sie sind auf dem neuesten Stand!",
    lastUpdated: "Zuletzt aktualisiert",
    tradeClosedTitle: "Trade erfolgreich geschlossen",
    tradeClosedMessage: "Ihre NQ1!-Position wurde für +$285 Gewinn geschlossen",
    minutesAgo: "vor {minutes} Minuten",
    payoutProcessedTitle: "Auszahlung bearbeitet",
    payoutProcessedMessage: "Ihre $2.450-Auszahlung wurde an Ihr Bankkonto gesendet",
    hourAgo: "vor 1 Stunde",
    achievementUnlockedTitle: "Achievement freigeschaltet!",
    achievementUnlockedMessage: "Sie haben das 'Risk Master'-Achievement verdient",
    hoursAgo: "vor {hours} Stunden",
    riskAlertTitle: "Risikomanagement-Warnung",
    riskAlertMessage: "Ihr Konto nähert sich dem täglichen Drawdown-Limit",
    marketUpdateTitle: "Markt-Update",
    marketUpdateMessage: "Hohe Volatilität während NFP-Veröffentlichung erwartet",
    dayAgo: "vor 1 Tag",
    accountVerifiedTitle: "Konto verifiziert",
    accountVerifiedMessage: "Ihre Identitätsverifizierung wurde abgeschlossen"
  },
  chatModal: {
    lastSeen: "Zuletzt gesehen",
    typeMessage: "Nachricht eingeben...",
    viewProfile: "Profil anzeigen",
    blockUser: "Benutzer blockieren",
    reportUser: "Benutzer melden",
    deleteChat: "Chat löschen"
  },
  chatOverview: {
    title: "Nachrichten",
    unread: "ungelesen",
    blockUser: "Benutzer blockieren",
    reportUser: "Benutzer melden",
    delete: "Löschen",
    noMessages: "Keine Nachrichten",
    startConversation: "Starten Sie eine Unterhaltung mit anderen Tradern",
    viewAllConversations: "Alle Unterhaltungen anzeigen",
    totalConversations: "Gesamt-Unterhaltungen",
    lastUpdated: "Zuletzt aktualisiert"
  },
  fundedAgreement: {
    title: "Finanzierungsvertrag",
    legalDocument: "Rechtsdokument",
    signToActivate: "Unterzeichnen Sie, um Ihr finanziertes Konto zu aktivieren",
    evaluationPassed: "Evaluierung bestanden",
    account: "Konto",
    finalPnL: "Finales P&L",
    evaluationResult: "Evaluierungsergebnis",
    passedDate: "Bestandsdatum",
    completionDate: "Abschlussdatum",
    fundedCapital: "Finanziertes Kapital",
    tradingCapital: "Trading-Kapital",
    agreementTerms: "Vertragsbedingungen",
    pleaseReviewCarefully: "Bitte sorgfältig prüfen vor Unterzeichnung",
    firstName: "Vorname",
    lastName: "Nachname",
    address: "Adresse",
    city: "Stadt",
    zipCode: "Postleitzahl",
    country: "Land",
    emailAddress: "E-Mail-Adresse",
    addressPlaceholder: "Geben Sie Ihre Straßenadresse ein",
    cityPlaceholder: "Geben Sie Ihre Stadt ein",
    zipCodePlaceholder: "Geben Sie Ihre Postleitzahl ein",
    countryPlaceholder: "Wählen Sie Ihr Land",
    digitalSignature: "Digitale Signatur",
    clear: "Löschen",
    signHereWithMouseOrFinger: "Hier mit Maus oder Finger unterschreiben",
    pleaseSignAboveToExecute: "Bitte unterschreiben Sie oben, um den Vertrag auszuführen",
    signToActivateAccount: "Unterzeichnen Sie, um Ihr Konto zu aktivieren",
    identificationDocument: "Ausweisdokument",
    uploadNewDocument: "Neues Dokument hochladen",
    useExistingDocument: "Vorhandenes Dokument verwenden",
    documentSecurity: "Dokumentensicherheit",
    documentSecurityDesc: "Alle Dokumente werden verschlüsselt und sicher in Übereinstimmung mit Datenschutzbestimmungen gespeichert.",
    printedName: "Gedruckter Name",
    printedNameDesc: "Geben Sie Ihren vollständigen rechtlichen Namen in Großbuchstaben ein",
    printedNameNote: "Dies sollte mit dem Namen auf Ihrem Ausweisdokument übereinstimmen",
    agreementCheckbox: "Ich habe alle Bedingungen dieses Finanzierungsvertrags gelesen und stimme ihnen zu",
    signAgreement: "Vertrag unterzeichnen",
    signingAgreement: "Vertrag wird unterzeichnet...",
    requirementsChecklist: "Anforderungs-Checkliste",
    personalDataComplete: "Persönliche Daten vollständig",
    agreementAcceptance: "Vertragsannahme",
    importantNotice: "Wichtiger Hinweis",
    noticeText1: "Dies ist ein rechtlich bindender Vertrag. Bitte lesen Sie alle Bedingungen sorgfältig vor der Unterzeichnung.",
    noticeText2: "Durch die Unterzeichnung dieses Vertrags bestätigen Sie, dass Sie alle Bedingungen verstehen und akzeptieren.",
    noticeText3: "Nach der Unterzeichnung kann dieser Vertrag nicht ohne gegenseitige Zustimmung beider Parteien geändert werden.",
    loadingContract: "Vertrag wird geladen...",
    errorLoadingContract: "Fehler beim Laden des Vertrags"
  },
  agreementSuccess: {
    title: "Vertrag erfolgreich unterzeichnet!",
    description: "Ihr Finanzierungsvertrag für Konto #{accountId} wurde unterzeichnet und bearbeitet.",
    accountCreationInfo: "Ihr finanziertes Konto wird vorbereitet und ist innerhalb von 24 Stunden verfügbar.",
    fundedFeeTitle: "Monatliche Finanzierungsgebühr",
    fundedFeeSubtitle: "Erforderlich für Kontoaktivierung",
    activeSubscription: "Aktives Abonnement",
    activeSubscriptionDesc: "Ihr Finanzierungsgebühren-Abonnement ist aktiv bis:",
    paymentRequired: "Zahlung erforderlich",
    paymentRequiredDesc: "Um Ihr finanziertes Konto zu aktivieren, zahlen Sie bitte die monatliche Finanzierungsgebühr von €95.",
    payFundedFee: "Finanzierungsgebühr zahlen (€95)",
    signedBy: "Unterzeichnet von",
    signedOn: "Unterzeichnet am",
    account: "Konto",
    status: "Status",
    active: "Aktiv",
    waitingForPayment: "Warten auf Zahlung",
    backToDashboard: "Zurück zum Dashboard",
    loadingStatus: "Vertragsstatus wird geladen...",
    accountActivating: "Konto wird aktiviert",
    accountActivatingDesc: "Ihr Funded-Konto wird in wenigen Sekunden aktiviert."
  },
  profile: {
    title: "Profil"
  },
  profileTabs: {
    activity: "Aktivität",
    achievements: "Achievements",
    connections: "Verbindungen",
    documents: "Dokumente",
    settings: "Einstellungen"
  },
  profileHeader: {
    publicProfile: "Öffentliches Profil",
    privateProfile: "Privates Profil",
    trades: "Trades",
    tradingDays: "Trading-Tage",
    seasons: "Saisons",
    joined: "Beigetreten",
    follow: "Folgen",
    message: "Nachricht",
    messagesDisabled: "Nachrichten deaktiviert"
  },
  userHeader: {
    eliteTrader: "Elite-Trader",
    higherProfitSplits: "Höhere Gewinnaufteilungen",
    prioritySupport: "Prioritäts-Support",
    exclusiveFeatures: "Exklusive Features",
    dayStreak: "Tage-Serie",
    day: "Tag",
    days: "Tage",
    tradingConsistency: "Trading-Konsistenz",
    currentStreak: "Aktuelle Serie",
    bestStreak: "Beste Serie",
    started: "Gestartet",
    lastTrade: "Letzter Trade",
    recentTradingDays: "Letzte Trading-Tage",
    trades: "Trades",
    keepTradingDaily: "Handeln Sie täglich, um Ihre Serie aufrechtzuerhalten!",
    amazingConsistency: "Erstaunliche Konsistenz! Sie sind in Fahrt!",
    greatMomentum: "Großartiger Schwung! Weiter so!",
    buildingHabits: "Großartige Trading-Gewohnheiten aufbauen!",
    keepItUp: "Weiter so! Jeder Tag zählt!",
    noStreakTitle: "Noch keine Serie",
    noStreakMessage: "Starte mit dem Traden, um dir eine Streak aufzubauen! Jeder Trading-Tag zahlt auf deine Konsistenz ein.",
    level: "Level",
    progressTo: "Fortschritt zu",
    currentLevel: "Aktuelles Level",
    nextLevel: "Nächstes Level Vorteile",
    nextRank: "Nächster Rang",
    nextRankAt: "ab Level",
    currentRank: "Aktueller Rang",
    rankBenefits: "Rang-Vorteile",
    maxRankReached: "Maximaler Rang erreicht!",
    rewardCredits: "Credits",
    rewardDiscount: "Einmaliger Rabatt",
    rewardFreeReset: "Kostenloser Reset",
    rewardFreeExtension: "Kostenlose Verlängerung",
    rewardTradingFee: "Trading-Gebühr",
    rewardDrawdownReduction: "Drawdown-Reduktion",
    account: "Konto",
    tier: "Status",
    accounts: "Konten",
    funded: "Funded",
    evaluation: "Evaluation",
    inactive: "Inaktiv"
  },
  achievements: {
    title: "Achievements",
    subtitle: "Ihre Trading-Meilensteine",
    completed: "abgeschlossen",
    progress: "Fortschritt",
    earned: "Verdient",
    remaining: "Verbleibend",
    previous: "Zurück",
    next: "Weiter",
    page: "Seite",
    of: "von",
    viewAll: "Alle Achievements anzeigen",
    achievementStatus: "Achievement-Status",
    loading: "Achievements werden geladen...",
    locked: "Gesperrt",
    noAchievements: "Noch keine Achievements",
    noAchievementsDesc: "Starten Sie mit dem Trading, um Ihr erstes Achievement freizuschalten und Ihren Fortschritt zu verfolgen!",
    startTrading: "Beginnen Sie Ihre Reise",
    rarity: {
      common: "Häufig",
      rare: "Selten",
      epic: "Episch",
      legendary: "Legendär",
      special: "Speziell"
    },
    firstProfit: {
      title: "Erster Gewinn",
      description: "Ihren ersten profitablen Trade gemacht"
    },
    profitStreak: {
      title: "Gewinnserie",
      description: "5 aufeinanderfolgende profitable Tage"
    },
    riskMaster: {
      title: "Risiko-Meister",
      description: "30 Tage lang nie 3% täglichen Drawdown überschritten"
    },
    speedDemon: {
      title: "Geschwindigkeitsdämon",
      description: "Evaluierung in 5 Tagen bestanden"
    },
    consistencyKing: {
      title: "Konsistenz-König",
      description: "15 Tage aktives Trading"
    },
    profitTarget: {
      title: "Gewinnziel",
      description: "6% Gewinnziel erreicht"
    },
    highRoller: {
      title: "High Roller",
      description: "Mit $100K+ Kapital handeln"
    },
    winStreak: {
      title: "Gewinnserie",
      description: "10 Gewinn-Trades in Folge"
    },
    perfectMonth: {
      title: "Perfekter Monat",
      description: "Keine Verlusttage in einem Monat"
    },
    volumeTrader: {
      title: "Volumen-Trader",
      description: "1000+ Trades ausführen"
    },
    profitMachine: {
      title: "Gewinn-Maschine",
      description: "$100K+ Gesamtgewinne verdienen"
    },
    diamondHands: {
      title: "Diamanthände",
      description: "Gewinnposition 24+ Stunden halten"
    }
  },
  achievementModal: {
    details: "Details",
    difficulty: "Schwierigkeit",
    status: "Status",
    earned: "Verdient",
    statusLocked: "Gesperrt",
    earnedOn: "Verdient am",
    progress: "Fortschritt",
    reward: "Belohnung",
    tips: "Tipps",
    unlocked: "Achievement freigeschaltet!",
    congratulations: "Herzlichen Glückwunsch zum Freischalten dieses Achievements!",
    locked: "Achievement gesperrt",
    completeRequirements: "Erfüllen Sie die Anforderungen, um dieses Achievement freizuschalten.",
    rarity: "Seltenheit",
    points: "Punkte",
    completed: "Abgeschlossen!",
    target: "Ziel",
    current: "Aktuell",
    description: "Beschreibung"
  },
  profileAchievements: {
    title: "Achievements",
    progress: "Fortschritt",
    rarityBreakdown: "Seltenheits-Aufschlüsselung",
    achievementDistribution: "Achievement-Verteilung",
    recentUnlocks: "Kürzliche Freischaltungen",
    latestAchievements: "Neueste Achievements",
    all: "Alle",
    earned: "erlangt",
    complete: "abgeschlossen",
    rarityDesc: {
      common: "Basis-Achievements",
      rare: "Fortgeschrittene Leistung",
      epic: "Außergewöhnliches Trading",
      legendary: "Elite-Meisterschaft",
      special: "Einzigartige Belohnungen"
    }
  },
  profileSeasons: {
    tradingSeasons: "Trading Seasons",
    season: "Saison",
    pastSeasons: "Vergangene Seasons",
    finalLevel: "Finales Level",
    level: "Level",
    current: "Aktuell"
  },
  profileTradingStats: {
    title: "Trading-Statistiken",
    totalTrades: "Gesamt-Trades",
    allTimeExecuted: "Jemals ausgeführt",
    tradedLots: "Gehandelte Lots",
    totalExecuted: "Insgesamt ausgeführt",
    winRate: "Gewinnrate",
    profitFactor: "Profit-Faktor",
    riskAdjusted: "Risikoadjustiert",
    averagePerformance: "Ø Performance",
    avgWin: "Ø Gewinn",
    avgLoss: "Ø Verlust",
    dailyProfit: "Ø Täglicher G/V",
    extremes: "Extreme",
    bestDay: "Bester Tag",
    worstDay: "Schlechtester Tag",
    tradingDays: "Trading-Tage",
    consistency: "Konsistenz",
    maxWins: "Max. Gewinne",
    maxLosses: "Max. Verluste",
    largestWin: "Größter Gewinn",
    tradingHoursDistribution: "Trading-Stunden-Verteilung",
    lots: "Lots",
    trades: "Trades",
    marketDistribution: "Markt-Verteilung",
    totalLots: "Gesamt-Lots",
    ofTotal: "von gesamt",
    noData: "Noch keine geschlossenen Trades vorhanden."
  },
  profileConnections: {
    title: "Trading-Netzwerk",
    tradingNetwork: "Trading-Netzwerk",
    connectWithTraders: "Mit Tradern verbinden",
    total: "Gesamt",
    followers: "Follower",
    following: "Folge ich",
    searchConnections: "Verbindungen suchen...",
    searchNewByUsername: "Neue nach Benutzername suchen...",
    userFound: "Benutzer gefunden",
    follow: "Folgen",
    notFound: "Nicht gefunden",
    tier: "Stufe",
    funded: "Finanziert",
    evaluation: "Evaluierung",
    seasons: "Saisons",
    trades: "Trades",
    lastActive: "Zuletzt aktiv",
    unfollow: "Entfolgen"
  },
  documents: {
    title: "Dokumente",
    documentCenter: "Dokumentenzentrum",
    invoicesAgreements: "Rechnungen & Verträge",
    invoiceTabTitle: "Rechnungen",
    agreementsTabTitle: "Verträge",
    all: "Alle",
    paid: "Bezahlt",
    active: "Aktiv",
    pending: "Ausstehend",
    searchInvoices: "Rechnungen suchen...",
    searchAgreements: "Verträge suchen...",
    invoices: "Rechnungen",
    invoicesFound: "Rechnungen gefunden",
    fundedAgreements: "Finanzierungsverträge",
    agreementsFound: "Verträge gefunden",
    invoice: "Rechnung",
    amount: "Betrag",
    fundedAgreement: "Finanzierungsvertrag",
    account: "Konto",
    signed: "Unterzeichnet",
    evaluationPassed: "Evaluierung bestanden",
    contractCreated: "Kontrakt erstellt",
    pendingSignature: "Ausstehende Unterschrift",
    completed: "Abgeschlossen",
    passedAccount: "Bestandenes Konto",
    fundedAccount: "Funded Konto",
    terminated: "Beendet",
    awaitingFee: "Warten auf Gebühr",
    payFundedFee: "Funded Fee zahlen",
    noInvoicesFound: "Keine Rechnungen gefunden",
    noInvoicesFoundCriteria: "Keine Rechnungen entsprechen Ihren aktuellen Suchkriterien.",
    status: {
      paid: "Bezahlt",
      active: "Aktiv",
      pending: "Ausstehend",
      terminated: "Beendet",
      Terminated: "Beendet",
      failed: "Fehlgeschlagen",
      Completed: "Abgeschlossen",
      PendingSignature: "Ausstehende Unterschrift",
      AwaitingFee: "Warten auf Gebühr",
      Provisioning: "Bereitstellung"
    }
  },
  profileSettings: {
    title: "Profil-Einstellungen",
    customizationHub: "Anpassungs-Hub",
    personalizeExperience: "Personalisieren Sie Ihre Erfahrung",
    profile: "Profil",
    privacy: "Datenschutz",
    notifications: "Benachrichtigungen",
    security: "Sicherheit",
    manageProfileInfo: "Verwalten Sie Ihre Profilinformationen",
    controlWhoCanSee: "Kontrollieren Sie, wer Ihre Informationen sehen kann",
    customizeNotifications: "Passen Sie Ihre Benachrichtigungen an",
    secureAccount: "Sichern Sie Ihr Konto",
    settingsSaved: "Einstellungen gespeichert!",
    savingChanges: "Änderungen werden gespeichert...",
    saveChanges: "Änderungen speichern",
    saveAllChanges: "Alle Änderungen speichern",
    settings: "Einstellungen"
  },
  profileTab: {
    profilePicture: "Profilbild",
    uploadNew: "Neues hochladen",
    remove: "Entfernen",
    uploading: "Wird hochgeladen...",
    uploadSuccess: "Profilbild erfolgreich aktualisiert",
    uploadError: "Upload fehlgeschlagen. Bitte erneut versuchen.",
    fileTooLarge: "Datei zu gross. Maximal 5 MB.",
    unsupportedFileType: "Dateityp nicht unterstuetzt. Verwende JPEG, PNG oder WebP.",
    basicInformation: "Grundinformationen",
    displayName: "Anzeigename",
    enterDisplayName: "Geben Sie Ihren Anzeigenamen ein",
    username: "Benutzername",
    enterUsername: "Geben Sie Ihren Benutzernamen ein",
    emailAddress: "E-Mail-Adresse",
    enterEmail: "Geben Sie Ihre E-Mail-Adresse ein",
    addressInformation: "Adressinformationen",
    street: "Strasse",
    enterStreet: "Geben Sie Ihre Strasse ein",
    street2: "Adresszeile 2",
    enterStreet2: "Wohnung, Suite, etc. (optional)",
    postalCode: "Postleitzahl",
    enterPostalCode: "Geben Sie Ihre Postleitzahl ein",
    city: "Stadt",
    enterCity: "Geben Sie Ihre Stadt ein",
    stateProvince: "Bundesland / Provinz",
    enterStateProvince: "Geben Sie Ihr Bundesland ein",
    country: "Land",
    selectCountry: "Waehlen Sie Ihr Land",
    addressSaved: "Adresse erfolgreich aktualisiert",
    addressSaveError: "Adresse konnte nicht aktualisiert werden. Bitte erneut versuchen.",
    savingAddress: "Wird gespeichert..."
  },
  privacyTab: {
    profileVisibility: "Profil-Sichtbarkeit",
    publicAnyone: "Öffentlich - Jeder kann anzeigen",
    followersOnly: "Nur Follower - Nur Follower können anzeigen",
    privateOnly: "Privat - Nur Sie können anzeigen",
    showAchievements: "Achievements anzeigen",
    showAchievementsDesc: "Zeigen Sie Ihre Achievements in Ihrem öffentlichen Profil an",
    allowMessages: "Nachrichten erlauben",
    allowMessagesDesc: "Erlauben Sie anderen Tradern, Ihnen Nachrichten zu senden"
  },
  notificationsTab: {
    emailNotifications: "E-Mail-Benachrichtigungen",
    emailNotificationsDesc: "Wichtige Updates per E-Mail erhalten",
    notifications: "Benachrichtigungen",
    pushNotifications: "Push-Benachrichtigungen",
    pushNotificationsDesc: "Echtzeit-Benachrichtigungen in Ihrem Browser erhalten",
    followerNotifications: "Follower-Benachrichtigungen",
    followerNotificationsDesc: "Benachrichtigung erhalten, wenn Ihnen jemand folgt",
    marketUpdates: "Markt-Updates",
    marketUpdatesDesc: "Wichtige Marktnachrichten und Updates erhalten",
    achievementNotifications: "Achievement-Benachrichtigungen",
    achievementNotificationsDesc: "Benachrichtigung erhalten, wenn Sie neue Achievements freischalten",
    emailFollowerNotifications: "E-Mail Follower-Benachrichtigungen",
    emailFollowerNotificationsDesc: "E-Mail erhalten, wenn Ihnen jemand folgt",
    emailMarketUpdates: "E-Mail Markt-Updates",
    emailMarketUpdatesDesc: "Marktnachrichten und Updates per E-Mail erhalten",
    emailAchievementNotifications: "E-Mail Achievement-Benachrichtigungen",
    emailAchievementNotificationsDesc: "Achievement-Benachrichtigungen per E-Mail erhalten"
  },
  securityTab: {
    changePassword: "Passwort ändern",
    changePasswordDesc: "Aktualisieren Sie Ihr Kontopasswort regelmäßig, um es sicher zu halten.",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmNewPassword: "Neues Passwort bestätigen",
    atLeast8Characters: "Mindestens 12 Zeichen",
    uppercaseLetter: "Großbuchstabe",
    lowercaseLetter: "Kleinbuchstabe",
    number: "Zahl",
    specialCharacter: "Sonderzeichen",
    passwordsDoNotMatch: "Passwörter stimmen nicht überein.",
    hidePassword: "Passwort ausblenden",
    showPassword: "Passwort anzeigen",
    reset: "Zurücksetzen",
    savePassword: "Passwort speichern",
    saving: "Speichern...",
    passwordChanged: "Passwort erfolgreich geändert!",
    passwordChangeFailed: "Passwort konnte nicht geändert werden. Bitte versuchen Sie es erneut.",
    reenterPassword: "Geben Sie Ihr neues Passwort erneut ein"
  },
  twoFactor: {
    title: "Zwei-Faktor-Authentifizierung",
    description: "Sichern Sie Ihr Konto mit einer zusätzlichen Schutzschicht.",
    authenticatorApp: "Authenticator-App",
    enabled: "Aktiv",
    disabled: "Inaktiv",
    enabledDesc: "Ihr Konto ist mit Zwei-Faktor-Authentifizierung geschützt.",
    disabledDesc: "Aktivieren Sie 2FA für zusätzliche Sicherheit.",
    enable: "Aktivieren",
    disable: "Deaktivieren",
    enabledSuccess: "Zwei-Faktor-Authentifizierung wurde erfolgreich aktiviert!",
    disabledSuccess: "Zwei-Faktor-Authentifizierung wurde deaktiviert.",
    disableFailed: "Deaktivierung der Zwei-Faktor-Authentifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    setupTitle: "2FA einrichten",
    setupSubtitle: "Sichern Sie Ihr Konto mit einer Authenticator-App",
    setupFailed: "2FA-Einrichtung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
    verifyFailed: "Verifizierung fehlgeschlagen. Bitte prüfen Sie den Code und versuchen Sie es erneut.",
    step1Title: "Authenticator-App installieren",
    step1Desc: "Laden Sie eine Authenticator-App auf Ihr Mobilgerät herunter. Sie werden diese verwenden, um Verifizierungscodes zu generieren.",
    recommendedApps: "Empfohlene Apps:",
    continue: "Weiter",
    initializing: "Wird initialisiert...",
    step2Title: "QR-Code scannen",
    step2Desc: "Öffnen Sie Ihre Authenticator-App und scannen Sie diesen QR-Code.",
    manualEntry: "Scannen nicht möglich? Geben Sie diesen Schlüssel manuell ein:",
    step3Title: "Einrichtung verifizieren",
    step3Desc: "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein, um die Einrichtung abzuschliessen.",
    verificationCode: "Verifizierungscode",
    back: "Zurück",
    activate: "2FA aktivieren",
    verifying: "Wird verifiziert...",
    switchToEmail: "Zurück zu Mail wechseln"
  },
  comparisonSection: {
    badge: "Warum Nextproptrader?",
    title: "Wir sind",
    titleHighlight: "Anders",
    titleEnd: "Als andere Prop-Firmen",
    subtitle: "Sehen Sie, warum Tausende von Tradern Nextproptrader gegenüber traditionellen Prop-Trading-Firmen wählen.",
    
    features: {
      profitSplit: "Gewinnaufteilung",
      payoutFrequency: "Auszahlungshäufigkeit",
      hiddenFees: "Versteckte Gebühren",
      platformQuality: "Plattform-Qualität",
      miniMicroScaling: "Mini/Micro-Skalierung",
      evaluationTime: "Evaluierungszeit"
    },
    
    nextprop: {
      profitSplit: "100%",
      payoutFrequency: "Täglich",
      hiddenFees: "Transparenz",
      platformQuality: "Einzigartig & Live",
      miniMicroScaling: "1:10 faire Skalierung",
      evaluationTime: "Nur 5 Tage"
    },
    
    others: {
      profitSplit: "75-90%",
      payoutFrequency: "Wöch./Monatlich",
      hiddenFees: "Mehrere Gebühren",
      platformQuality: "Basis/Begrenzt",
      miniMicroScaling: "1:1 ungünstig",
      evaluationTime: "10-30+ Tage"
    },
    
    table: {
      features: "Funktionen",
      featuresDesc: "Was am wichtigsten ist",
      nextproptrader: "Nextproptrader",
      industryLeader: "BRANCHENFÜHRER",
      otherPropFirms: "Andere Prop-Firmen",
      industryStandard: "Branchenstandard"
    },
    
    summary: {
      title: "Der klare Gewinner",
      description: "Nextproptrader übertrifft andere Prop-Firmen durchweg in allen wichtigen Kennzahlen, die für Trader wichtig sind."
    },
    
    benefits: {
      profitSplit: {
        title: "100% Gewinnaufteilung",
        description: "Behalten Sie alles, was Sie verdienen. Keine versteckten Kürzungen oder Gebühren."
      },
      dailyPayouts: {
        title: "Tägliche Auszahlungen",
        description: "Greifen Sie sofort auf Ihre Gewinne zu, nicht erst Wochen später."
      },
      transparentRules: {
        title: "Transparente Regeln",
        description: "Klare, faire Regeln ohne überraschende Einschränkungen."
      },
      fastEvaluation: {
        title: "Schnelle Evaluierung",
        description: "Erhalten Sie eine Kapitalisierung in nur 5 Handelstagen."
      }
    },
    
    cta: {
      title: "Bereit, den",
      titleHighlight: "Unterschied zu erleben?",
      description: "Schließen Sie sich Tausenden von Tradern an, die zu einer besseren Prop-Trading-Erfahrung gewechselt sind.",
      button: "Starten Sie Ihre Evaluierung"
    }
  },
  transparencySection: {
    badge: "Pure Transparenz",
    title: "Nur 2 einfache Regeln.",
    titleHighlight: "Keine versteckten Fallen.",
    subtitle: "Während andere Prop-Firmen dich mit komplexen Regelwerken begraben um Auszahlungen zu vermeiden, halten wir es radikal einfach. Zwei klare Consistency-Regeln im Funded — das war's.",
    others: {
      title: "Andere Prop-Firmen",
      subtitle: "Komplexe Regeln, die dich scheitern lassen sollen",
      rule1: "Komplexe Consistency-Regeln, die ohne Vorankündigung geändert werden",
      rule2: "Kontolöschung nach nur 6 Auszahlungen — von vorne anfangen",
      rule3: "Versteckte Einschränkungen, die erst bei der Auszahlung auftauchen",
      rule4: "Ausgeklügelte Regelsysteme, die Auszahlungen nahezu unmöglich machen",
      rule5: "Neue Regeln, die rückwirkend auf bestehende Konten angewendet werden"
    },
    us: {
      title: "Nextproptrader",
      subtitle: "Nur 2 klare Funded-Regeln",
      rule1: "Lucky Punch Regel: Kein einzelner Trade darf mehr als 30% des Gesamt-PnL ausmachen",
      rule2: "Scaling Plan: Alle $2.500 Gewinn wird ein weiterer Kontrakt freigeschaltet",
      rule3: "Das war's. Keine versteckten Regeln, keine Überraschungen, kein Kleingedrucktes",
      conclusion: "Zwei Regeln. Volle Transparenz. Dein Erfolg ist das Einzige, was zählt."
    },
    rules: {
      luckyPunch: {
        title: "Lucky Punch Regel",
        description: "Dein größter einzelner Trade darf nicht mehr als 30% deines Gesamtgewinns ausmachen. Das stellt sicher, dass du konstante Performance aufbaust — und nicht auf einen Glückstreffer setzt.",
        exampleTitle: "Praxisbeispiel",
        example: {
          passLabel: "Konform",
          passText: "Gesamt-PnL: $5.000. Größter Trade: $1.200 (24%). Das liegt deutlich unter dem 30%-Limit — konstantes Trading, keine Probleme.",
          failLabel: "Nicht Konform",
          failText: "Gesamt-PnL: $3.000. Größter Trade: $1.500 (50%). Ein einzelner Trade macht mehr als 30% aus — das deutet auf einen Glückstreffer statt konstantes Trading hin.",
          note: "Diese Regel stellt einfach sicher, dass deine Gewinne aus konsistenter Fähigkeit kommen, nicht aus einem einzelnen Ausreißer-Trade. Sie schützt sowohl dich als auch die Firma."
        }
      },
      scalingPlan: {
        title: "Scaling Plan",
        description: "Du startest mit einer Basis-Anzahl an Kontrakten. Für jeden $2.500 Gewinn wird ein weiterer Kontrakt freigeschaltet. So stellst du sicher, dass du dein Trading sicher skalierst, während dein Konto wächst.",
        exampleTitle: "Praxisbeispiel",
        example: {
          passLabel: "Beispiel-Progression",
          passText: "Du startest mit 1 Kontrakt. Nach $2.500 Gewinn kannst du 2 Kontrakte traden. Nach $5.000 Gesamtgewinn schaltest du 3 Kontrakte frei — und so weiter, Schritt für Schritt.",
          failLabel: "Was nicht funktioniert",
          failText: "Am ersten Tag mit einem frischen Funded-Konto direkt 5 Kontrakte traden. Der Scaling Plan stellt sicher, dass du deine Größe schrittweise aufbaust, während deine Gewinne beweisen, dass du bereit bist.",
          note: "Der Scaling Plan schützt dein Konto vor übermäßigem Risiko in der Anfangsphase. Wenn deine Gewinne wachsen, wächst auch deine Trading-Kapazität natürlich mit."
        }
      }
    },
    showExample: "Beispiel anzeigen",
    hideExample: "Beispiel ausblenden",
    bottom: {
      title: "Kein Kleingedrucktes.",
      titleHighlight: "Einfach faires Trading.",
      description: "Während Wettbewerber neue Regeln erfinden um dich nicht auszuzahlen, geben wir dir genau zwei einfache Consistency-Regeln. Alles andere liegt in deinen Händen. Trade auf deine Art — werde auf deine Art bezahlt."
    }
  },
  platformSection: {
    badge: "NEXTPROPTRADER",
    title: "Warum Prop Trader",
    titleHighlight: "Uns Wählen",
    subtitle: "Von zuverlässigen Auszahlungen bis hin zu einem echten trading-orientierten Modell bieten wir die Infrastruktur, den Support und die Vision, die ernsthafte Trader für ihren Erfolg benötigen.",
    
    features: {
      reliablePayouts: {
        title: "Zuverlässige Auszahlungen",
        description: "Im Gegensatz zu vielen Firmen, die Ausreden erfinden, um Ihre Gewinne einzubehalten, haben wir noch nie eine Auszahlung verpasst. Punkt. Lassen Sie sich zuverlässig per Banküberweisung, PayPal oder Krypto auszahlen — keine Verzögerungen, kein Drama."
      },
      technology: {
        title: "Branchenführende Technologie",
        description: "Von der Konnektivität bis zu unserem Trader-Dashboard gehört unsere Technologie zu den fortschrittlichsten der Branche. Wir innovieren ständig, um einen Schritt voraus zu sein — und geben Ihnen die Geschwindigkeit, Stabilität und Tools, die Sie für Ihre Performance benötigen."
      },
      partnerships: {
        title: "Langfristige Partnerschaften",
        description: "Wir suchen nicht nach einmaligen Evaluierungen — wir sind hier, um langfristige Beziehungen aufzubauen. Durch unser Programm erhalten erfolgreiche Trader Zugang zu exklusiven Möglichkeiten und tieferer Kapitalskalierung im Laufe der Zeit."
      },
      builtToTrade: {
        title: "Fürs Trading Gebaut — Nicht Nur Zum Verkaufen",
        description: "Im Gegensatz zu Discount-Prop-Firmen, die nur von Evaluierungsgebühren überleben, betreiben wir echte Infrastruktur, die von tatsächlicher Trading-Performance lebt. Unser Geschäftsmodell ist auf Ihren Erfolg ausgerichtet — denn wir wachsen, wenn Sie wachsen."
      }
    },
    
    profitSplit: {
      title: "Gewinnaufteilung",
      subtitle: "Branchenführend",
      badge: "BRANCHENFÜHREND",
      keepEverything: "Sie Behalten Alles Was Sie Verdienen"
    },
    
    explanation: {
      title: "Warum 100% Gewinnaufteilung?",
      believeInSuccess: "Wir glauben an Ihren Erfolg.",
      paragraph1: "Im Gegensatz zu traditionellen Prop-Firmen, die 10-20% Ihrer Gewinne nehmen, lassen wir Sie 100% von dem behalten, was Sie verdienen, weil Ihre Trading-Fähigkeiten die volle Belohnung verdienen.",
      paragraph2: "Wir nehmen keinen Anteil — weil wir mit Ihnen skalieren. Wenn Sie finanziert sind und gut performen, replizieren wir Ihre Trades im Hintergrund mit größeren Positionsgrößen. Sie behalten 100% Ihrer Gewinne — wir verdienen durch die Skalierung Ihres Vorteils. Ein Win-Win-Modell basierend auf Vertrauen und Performance."
    },
    
    benefits: {
      hiddenFees: {
        value: "0€",
        label: "Versteckte Gebühren"
      },
      earningPotential: {
        value: "∞",
        label: "Verdienstpotential"
      }
    }
  },
  tradingActivity: {
    title: "Trading-Aktivität",
    subtitle: "Live-Performance",
    description: "Echtzeit-Trading-Performance und Analytik"
  },
  recentTrades: {
    title: "Heutige Trades",
    subtitle: "Neueste Trading-Aktivität",
    quantity: "Lots",
    entry: "Einstieg",
    current: "Aktuell",
    exit: "Ausstieg",
    pnl: "P&L",
    duration: "Dauer",
    running: "Laufend",
    open: "Offen",
    closed: "Geschlossen",
    winners: "Gewinner",
    losers: "Verlierer",
    tradedLots: "Gehandelte Lots",
    avgNetPnL: "Ø Netto-P&L",
    noTrades: "Keine Trades für heute",
    noTradesDesc: "Es wurden heute noch keine Trades ausgeführt"
  },
  pnlCalendar: {
    title: "P&L Kalender",
    subtitle: "Tägliche Performance-Übersicht",
    allAccounts: "Alle Konten",
    totalPnl: "Gesamt P&L",
    totalTrades: "Trades",
    winDays: "Gewinntage",
    lossDays: "Verlusttage",
    days: {
      sun: "So",
      mon: "Mo",
      tue: "Di",
      wed: "Mi",
      thu: "Do",
      fri: "Fr",
      sat: "Sa"
    }
  },
  panelSwitcher: {
    performance: "Performance",
    trades: "Trades"
  },
  dailyPerformanceChart: {
    title: "Performance-Chart",
    subtitle: "Letzte 14 Handelstage",
    today: "heute",
    dailyPnL: "Tägliches P&L",
    tradePnL: "Trade P&L",
    bestDay: "Bester Tag",
    bestTrade: "Bester Trade",
    avgDaily: "Ø täglich",
    avgPnLToday: "Ø P&L Heute",
    last14Days: "letzte 14 Tage",
    worstDay: "Schlechtester Tag",
    worstTrade: "Schlechtester Trade",
    trades: "Trades",
    tradingDays: "Handelstage",
    perDay: "pro Tag"
  },
  accountPerformance: {
    title: "Konto-Performance",
    subtitle: "Alle Trading-Konten",
    leading: "Führend",
    since: "Seit",
    noData: "Keine Daten verfügbar",
    account: "Konto",
    startBalance: "Startguthaben",
    balance: "Guthaben",
    netPnL: "Netto-P&L",
    performance: "Performance",
    todaysPnL: "Heutiges P&L"
  },
  todaysSession: {
    title: "Heutige Session",
    livePerformance: "Live-Performance",
    active: "Aktiv",
    totalTrades: "Gesamt-Trades",
    sessionPnL: "Session G&V",
    winRate: "Gewinnrate",
    winningTrades: "Gewinn-Trades",
    losingTrades: "Verlust-Trades",
    avgWin: "Ø Gewinn",
    avgLoss: "Ø Verlust",
    largestWin: "Größter Gewinn",
    largestLoss: "Größter Verlust",
    avgTradeDuration: "Ø Trade-Dauer",
    sessionSummary: "Zusammenfassung"
  },
  controlPanel: {
    title: "Kontrollpanel",
    subtitle: "Trade-Management",
    live: "Live",
    openPositions: "Offene Positionen",
    active: "aktiv",
    noOpenPositions: "Keine offenen Positionen",
    quickActions: "Schnelle Aktionen",
    closeAllPositions: "Alle Positionen schließen",
    closingPositions: "Positionen werden geschlossen...",
    close: "Schließen",
    closing: "Schließe...",
    confirmCloseAll: "Alle Positionen schließen?",
    confirmMessage: "Sind Sie sicher, dass Sie alle {count} offenen Positionen schließen möchten?",
    cancel: "Abbrechen",
    closeAll: "Alle schließen"
  },
  addAccountModal: {
    title: "Neues Konto hinzufügen",
    subtitle: "Wählen Sie Ihr Evaluierungskonto",
    mostPopular: "AM BELIEBTESTEN",
    tradingCapital: "Trading-Kapital",
    only: "Nur",
    per30Days: "/30 Tage",
    getAccess: "Erhalten Sie Zugang zu",
    capital: "Kapital",
    startEvaluation: "EVALUIERUNG STARTEN",
    allPlansInclude: "Alle Pläne beinhalten",
    fullPlatformAccess: "Vollständiger Plattformzugang",
    completeAccess: "Kompletter Zugang zu allen Trading-Tools",
    level2MarketData: "Level 2 Marktdaten",
    chooseDataFeed: "Wählen Sie Ihren bevorzugten Datenfeed",
    premiumSupport: "Premium Support",
    professionalSupport: "24/7 professioneller Trading-Support"
  },
  footer: {
    traderFunding: "Trader-Kapitalisierung",
    description: "Wir helfen Tradern dabei, ihre simulierte Performance durch Kapitalisierungsprogramme, professionelle Tools und echte Trading-Umgebungen zu monetarisieren — ohne persönliches Kapital zu riskieren.",
    newsletter: {
      title: "Exklusive Angebote & Limitierte Rabatte",
      description: "Seien Sie einer der Ersten, der über zeitlich begrenzte Angebote und exklusive Trader-Rabatte erfährt.",
      placeholder: "Geben Sie Ihre E-Mail-Adresse ein",
      subscribe: "Kostenlos anmelden",
      privacy: "Kein Spam. Jederzeit abbestellbar. Ihre Daten sind geschützt.",
      subscribing: "Wird angemeldet...",
      successMessage: "Bitte prüfen Sie Ihre E-Mails und bestätigen Sie Ihre Anmeldung.",
      errorMessage: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      confirm: {
        title: "Anmeldung bestätigen",
        subtitle: "Newsletter-Bestätigung",
        confirming: "Ihre Anmeldung wird bestätigt...",
        success: "Ihre Anmeldung wurde erfolgreich bestätigt!",
        successDetail: "Sie erhalten ab sofort unsere neuesten Angebote und exklusiven Rabatte direkt in Ihr Postfach.",
        error: "Bestätigung fehlgeschlagen. Der Link ist möglicherweise ungültig oder abgelaufen.",
        backToHome: "Zurück zur Startseite"
      },
      unsubscribe: {
        title: "Newsletter abbestellen",
        subtitle: "Newsletter-Einstellungen",
        description: "Möchten Sie sich wirklich vom Newsletter abmelden? Sie erhalten dann keine exklusiven Angebote und Rabatte mehr.",
        button: "Abbestellen",
        unsubscribing: "Wird abgemeldet...",
        success: "Sie wurden erfolgreich abgemeldet.",
        successDetail: "Sie erhalten keine Newsletter-E-Mails mehr von uns.",
        error: "Abmeldung fehlgeschlagen. Der Link ist möglicherweise ungültig oder abgelaufen.",
        backToHome: "Zurück zur Startseite"
      }
    },
    ourProgram: {
      title: "Unser Programm",
      fundingProcess: "Der Kapitalisierungsprozess",
      softwareSolution: "Unsere Software-Lösung",
      profitSplit: "100% Gewinnaufteilung",
      pricing: "Unsere Preise"
    },
    association: {
      title: "Partnerschaften",
      partnership: "Partnerschaft",
      whiteLabel: "White Label",
      affiliateProgram: "Affiliate-Programm"
    },
    support: {
      title: "Support",
      faq: "FAQ",
      contact: "Kontakt"
    },
    copyright: "© {year} Nextproptrader LLC. All rights reserved.",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    disclaimers: {
      generalDisclosure: {
        title: "General Disclosure",
        content: "The materials and content provided by Nextproptrader LLC, whether on our website, through distributed documents, or other communications, are intended solely for general informational purposes. This content does not constitute investment advice, an offer to buy or sell securities, or an endorsement of any financial instruments, companies, or funds. Users should not interpret the information as personalized financial advice. The information provided is not targeted at any specific jurisdiction and should not be used in any manner that would contravene local laws or regulations. Nextproptrader LLC, a registered entity in Business Center 1, M Floor, Meydan Grand Stand, Dubai, UAE, adheres to all relevant local, state, and federal laws. © {year}. All rights reserved."
      },
      riskDisclosure: {
        title: "Risk Disclosure",
        content: "Trading futures, forex, and other leveraged products involves substantial risk of loss and is not suitable for all investors. Past performance is not necessarily indicative of future results. You should carefully consider whether trading is suitable for you in light of your circumstances, knowledge, and financial resources. You may lose all or more of your initial investment. Opinions, market data, and recommendations are subject to change at any time. Nextproptrader is not a registered investment advisor and does not provide investment advice. All trading decisions are made by the individual trader."
      },
      hypotheticalPerformance: {
        title: "Hypothetical Performance Disclosure",
        content: "Hypothetical performance results have many inherent limitations. No representation is being made that any account will or is likely to achieve profits or losses similar to those shown. In fact, there are frequently sharp differences between hypothetical performance results and the actual results subsequently achieved by any particular trading program. One of the limitations of hypothetical performance results is that they are generally prepared with the benefit of hindsight. In addition, hypothetical trading does not involve financial risk, and no hypothetical trading record can completely account for the impact of financial risk in actual trading. The ability to withstand losses or to adhere to a particular trading program in spite of trading losses are material points which can also adversely affect actual trading results."
      },
      finalNotice: "This website and its content are for informational purposes only. Trading involves risk and may not be suitable for all investors. Please read all risk disclosures before trading. Nextproptrader LLC is not responsible for any trading losses incurred by users of this platform."
    },
    systemStatus: {
      title: "Systemstatus",
      subtitle: "Echtzeit-Plattform-Überwachung",
      allSystemsOperational: "Alle Systeme funktionsfähig",
      platformRunning: "Plattform läuft reibungslos",
      overallUptime: "Gesamte Betriebszeit",
      coreSystems: "Kernsysteme",
      marketDataFeeds: "Marktdaten-Feeds",
      operational: "Funktionsfähig",
      maintenance: "Wartung",
      uptime: "Betriebszeit",
      responseTime: "Antwortzeit",
      latency: "Latenz",
      statusUpdates: "Status-Updates",
      lastUpdated: "Zuletzt aktualisiert",
      refreshes: "Aktualisiert alle 30 Sekunden",
      liveMonitoring: "Live-Überwachung",
      systems: {
        tradingPlatform: {
          name: "Trading-Plattform",
          description: "Kern-Trading-Infrastruktur"
        },
        userDashboard: {
          name: "Benutzer-Dashboard",
          description: "Kontoverwaltungssystem"
        },
        paymentSystem: {
          name: "Zahlungssystem",
          description: "Auszahlungsverarbeitung"
        },
        apiServices: {
          name: "API-Services",
          description: "Drittanbieter-Integrationen"
        }
      },
      dataFeeds: {
        rithmic: "Futures-Marktdaten",
        dxfeed: "Multi-Asset-Marktdaten"
      }
    }
  },
  hero: {
    badge: "Nextproptrader 2.0 – Prop Trading, neu definiert.",
    headline1: "Deine Trades.",
    headline2: "Unser Kapital.",
    headline3: "Echte Gewinne.",
    description: "Mit uns kannst du dein Sim-Trading monetarisieren — völlig risikofrei. Trade in einer sicheren Umgebung und erhalte",
    profitSplit: "100% deiner Gewinne",
    descriptionEnd: ". Kein Stress — nur deine Fähigkeiten, die zu echten Gewinnen werden.",
    getFundedButton: "Jetzt Kapitalisierung erhalten",
    learnMoreButton: "Mehr erfahren",
    stats: {
      capitalAllocated: "In Kapitalisierungen",
      capitalSubtitle: "Finanziertes Kapital",
      fundedAccounts: "Kapitalisierte Konten",
      accountsSubtitle: "Vertraut von Tausenden",
      tradesExecuted: "Ausgeführte Trades",
      tradesSubtitle: "Millionen Ideen. Eine Plattform."
    },
    dashboard: {
      title: "Dashboard",
      subtitle: "Live Trading Umgebung",
      fundedBadge: "Funded",
      accountBalance: "Kontostand",
      todayPerformance: "heute",
      possiblePayout: "Mögliche Auszahlung",
      payoutButton: "Auszahlen",
      profitSplit: "100%",
      profitSplitLabel: "Gewinnaufteilung",
      instrument: "NQ1! Futures",
      liveData: "Live Daten",
      todayProfit: "heute"
    }
  },
  header: {
    process: "Prozess",
    pricing: "Preise",
    payouts: "Auszahlungen",
    contact: "Kontakt",
    login: "Anmelden",
    register: "Registrieren",
    getStarted: "Registrieren",
    backToMainSite: "Zurück zur Hauptseite"
  },
  logoutModal: {
    title: 'Abmeldung läuft',
    subtitle: 'Bitte warten Sie, während wir Sie sicher abmelden',
    loggingOut: 'Abmeldung läuft...',
    securityMessage: 'Wir löschen sicher Ihre Sitzung und schützen Ihre Kontodaten.'
  },
  loginModal: {
    welcomeBack: "Willkommen zurück",
    signInToAccount: "Melden Sie sich in Ihrem Konto an",
    resetPassword: "Einloggen",
    enterEmailToReset: "Passwort zurückzusetzen",
    resetInstructions: "Geben Sie Ihre E-Mail-Adresse ein, um das Passwort zurückzusetzen",
    resetLinkSent: "Bitte überprüfen Sie Ihre Emails",
    sendingResetLink: "Link wird gesendet...",
    emailAddress: "E-Mail-Adresse",
    enterYourEmail: "Geben Sie Ihre E-Mail ein",
    emailOrUsername: "E-Mail oder Benutzername",
    enterEmailOrUsername: "E-Mail oder Benutzername eingeben",
    password: "Passwort",
    enterYourPassword: "Geben Sie Ihr Passwort ein",
    rememberMe: "Angemeldet bleiben",
    forgotPassword: "Passwort vergessen?",
    signIn: "Anmelden",
    enterEmailAddress: "Geben Sie Ihre E-Mail-Adresse ein",
    resetLinkInfo: "Wir senden Ihnen einen sicheren Link zum Zurücksetzen Ihres Passworts. Bitte überprüfen Sie Ihren E-Mail-Posteingang und Spam-Ordner.",
    sendResetLink: "Reset-Link senden",
    resendInSeconds: "Erneut senden in {s}s möglich",
    backToLogin: "← Zurück zur Anmeldung",
    or: "oder",
    dontHaveAccount: "Haben Sie noch kein Konto?",
    createOneNow: "Jetzt erstellen",
    signingIn: "Anmeldung läuft...",
    enterSecurityCode: "Sicherheits Code",
    enterCodeFromApp: "OTP Authentifizierung",
    enterCodeFromEmail: "Geben Sie den Code aus Ihrer E-Mail ein",
    securityCode: "Geben Sie den Code ein:",
    verifyAndSignIn: "Anmelden",
    verifying: "Verifizierung",
    resetError: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    setNewPassword: "Neues Passwort",
    enterNewPasswordSubtitle: "Legen Sie Ihr neues Passwort fest",
    newPasswordInstructions: "Bitte geben Sie Ihr neues Passwort ein. Es muss mindestens 8 Zeichen lang sein.",
    newPassword: "Neues Passwort",
    enterNewPassword: "Neues Passwort eingeben",
    confirmPassword: "Passwort bestätigen",
    repeatNewPassword: "Neues Passwort wiederholen",
    passwordsMismatch: "Die Passwörter stimmen nicht überein.",
    passwordTooShort: "Das Passwort muss mindestens 12 Zeichen lang sein und eine Zahl sowie ein Sonderzeichen enthalten.",
    resettingPassword: "Wird gespeichert...",
    saveNewPassword: "Neues Passwort speichern",
    passwordResetSuccess: "Passwort geändert",
    passwordResetSuccessMessage: "Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
    backToLoginButton: "Zurück zur Anmeldung",
    loginFailed: "Anmeldung fehlgeschlagen. Bitte überprüfe deine E-Mail/Benutzername und Passwort.",
    accountBlocked: "Dein Konto ist gesperrt. Bitte melde dich beim Support unter support@nextproptrader.com"
  },
  evaluationProcess: {
    badge: "Ihr Weg Zur Kapitalisierung",
    title: "Einfacher",
    titleHighlight: "4-Schritt",
    titleEnd: "Evaluierungsprozess",
    subtitle: "Unser optimierter Evaluierungsprozess ist darauf ausgelegt, talentierte Trader zu identifizieren und schnell zu kapitalisieren.",
    
    steps: {
      step1: {
        title: "Starten Sie Ihre Evaluation",
        subtitle: "Trading beginnen",
        description: "Wählen Sie Ihre Kontogröße und beginnen Sie mit unserem simulierten Kapital zu handeln. Kein Risiko für Ihr eigenes Geld.",
        duration: "Tag 1",
        requirement: "Konto-Setup"
      },
      step2: {
        title: "Gewinnziel erreichen",
        subtitle: "Beweisen Sie Ihre Fähigkeiten",
        description: "Erreichen Sie Ihr Gewinnziel und befolgen Sie dabei unsere Risikomanagement-Regeln. Zeigen Sie konstante Trading-Performance.",
        duration: "5-30 Tage",
        requirement: "6-8% Gewinnziel"
      },
      step3: {
        title: "Risikomanagement",
        subtitle: "Innerhalb der Grenzen bleiben",
        description: "Halten Sie während der gesamten Evaluierung ein ordnungsgemäßes Risikomanagement ein. Überschreiten Sie niemals die maximalen Drawdown-Grenzen.",
        duration: "Laufend",
        requirement: "Max. Drawdown"
      },
      step4: {
        title: "Evaluation starten",
        subtitle: "Echtes Kapital erhalten",
        description: "Herzlichen Glückwunsch! Sie haben die Evaluierung bestanden und erhalten nun Zugang zu Ihrem finanzierten Konto.",
        duration: "In wenigen Minuten",
        requirement: "Konto-Aktivierung"
      }
    },
    
    stepContent: {
      step1: {
        chooseCapital: "Kapital wählen",
        availableRange: "$10K - $250K verfügbar",
        startTrading: "Trading starten",
        beginImmediately: "Sofort beginnen"
      },
      step2: {
        profitTargetProgress: "Gewinnziel-Fortschritt",
        ofAmount: "von $50K = $3.000"
      },
      step3: {
        riskManagement: "Risikomanagement",
        withinLimits: "✓ Innerhalb der Grenzen",
        maxDrawdown: "Max. Drawdown",
        dependsOnAccount: "abhängig von der Kontogröße"
      },
      step4: {
        congratulations: "Herzlichen Glückwunsch!",
        accountPreparing: "Ihr kapitalisiertes Konto wird vorbereitet"
      }
    },
    
    rules: {
      title: "Evaluierungs",
      titleHighlight: "Regeln",
      subtitle: "Einfache und transparente Regeln für Ihren Evaluierungserfolg",
      
      rule1: {
        title: "5 Tage Funding",
        description: "Erhalten Sie nach 5 Handelstagen eine Kapitalisierung und es gibt auch kein Maximum. Sie können sich so viel Zeit nehmen, wie Sie brauchen."
      },
      rule2: {
        title: "Max. Lot-Größe",
        description: "Überschreiten Sie nicht die maximale Anzahl von Lots, die für Sie zulässig ist. Jedes Konto hat ein anderes Limit."
      },
      rule3: {
        title: "Max. Verlustgrenze",
        description: "Begrenzen Sie Ihr Risiko und handeln Sie effektiv. Sie dürfen nicht unter den Trailing Drawdown fallen."
      },
      rule4: {
        title: "Handelszeit",
        description: "Sie müssen alle Positionen spätestens um 15:15 Uhr CST schließen. Der Handel beginnt wieder um 17:00 Uhr CST."
      }
    }
  },
  solutions: {
    badge: "Trader Mit Proprietärer Präzision Stärken",
    title: "Entwickelt für",
    titleHighlight: "Professionelles",
    titleEnd: "Prop-Trading",
    subtitle: "Unsere professionelle Plattform bietet die Tools und Infrastruktur, die Prop-Trader benötigen, um in den heutigen Futures-Märkten erfolgreich zu sein.",
    poweredBy: "Unterstützt durch:",

    premiumDataFeeds: {
      title: "Premium-Datenfeeds",
      description: "Professionelle CME-Marktdaten von branchenführenden Anbietern mit Echtzeit-Ausführung.",
      dataPartners: "Unsere Datenpartner:",
      subtitle: "Echtzeit Level 2 Daten",
      badge: "CME-Marktdaten"
    },

    dailyPayouts: {
      title: "Tägliche Auszahlungen",
      description: "Schnelle und flexible Auszahlungsoptionen mit täglichen Abhebungen über mehrere Zahlungsmethoden.",
      badge: "Schnell & Flexibel",
      features: {
        dailyWithdrawals: "Tägliche Abhebungen",
        bankTransfer: "Banküberweisung",
        paypalCrypto: "PayPal & Krypto"
      }
    },
    
    payoutMethods: {
      bank: "Bank",
      transfer: "Überweisung",
      paypal: "PayPal",
      payments: "Zahlungen",
      crypto: "Krypto",
      downloadReceipt: "Beleg herunterladen"
    },
    
    payoutDemo: {
      approved: "AUSZAHLUNG GENEHMIGT",
      paid: "BEZAHLT",
      amount: "Auszahlungsbetrag",
      date: "Datum:",
      to: "An:",
      method: "Methode:",
      account: "Konto:",
      congratulations: "Herzlichen Glückwunsch zur Auszahlung!",
      fundsTransferred: "Ihre Gelder wurden erfolgreich auf Ihr Konto überwiesen."
    }
  },
  platformShowcase: {
    badge: "Eine Plattform. Alle Tools. Keine Grenzen.",
    title: "All-in-One",
    titleHighlight: "Trading Hub",
    titleEnd: "für Prop Trader",
    subtitle: "All Ihr Trading. Ein intelligentes Dashboard. Analysieren, verwalten und ausführen — schneller, klarer, besser.",
    
    platform: {
      dashboard: "Dashboard",
      subtitle: "Eine einheitliche Oberfläche",
      badge: "NXT Hub 2.0",
      liveData: "Live Daten",
      currentSlideTitle: "Erweiterte Chart-Suite"
    },
    
    features: {
      security: "Extrem hohe Sicherheit",
      securityDesc: "256-Bit-Verschlüsselung",
      execution: "Ultraschnelle Ausführung",
      executionDesc: "Sub-Millisekunde",
      indicators: "100+ Indikatoren",
      indicatorsDesc: "Technische Analyse",
      awardWinning: "Preisgekrönt",
      awardWinningDesc: "Branchenführer"
    },
    
    floating: {
      realTimeData: "Echtzeit-Marktdaten",
      advancedAnalytics: "Erweiterte Analytik",
      lightningExecution: "Blitzschnelle Ausführung",
      uptime: "Betriebszeit",
      latency: "Latenz",
      support: "Support"
    }
  },
  pricingSection: {
    badge: "Wählen Sie Ihr Trading-Kapital",
    title: "Starten Sie das Trading mit",
    titleHighlight: "Unserem Kapital",
    subtitle: "Wählen Sie die perfekte Kontogröße für Ihren Trading-Stil. Alle Pläne beinhalten vollen Plattformzugang und professionellen Support.",
    mostPopular: "Am beliebtesten",
    tradingCapital: "Trading-Kapital",
    only: "Nur",
    month: "Monat",
    per30Days: "/{{days}} Tage",
    getAccess: "Erhalten Sie Zugang zu {{capital}} Kapital",
    getFunded: "Evaluation starten",
    allPlansInclude: "Alle Pläne Beinhalten",
    fullPlatformAccess: "Vollständiger Plattformzugang",
    completeAccess: "Kompletter Zugang zu allen Trading-Tools",
    level2MarketData: "Level 2 Marktdaten",
    chooseDataFeed: "Wählen Sie Ihren bevorzugten Datenfeed",
    premiumSupport: "Premium Support",
    professionalSupport: "24/7 professioneller Trading-Support",
    minTradingDays_one: "Min. {{days}} Trading-Tag",
    minTradingDays_other: "Min. {{days}} Trading-Tage",
    profitSplit: "{{split}}% Gewinnbeteiligung",
    maxLots_one: "Max. {{lots}} Lot ({{micros}} Micros)",
    maxLots_other: "Max. {{lots}} Lots ({{micros}} Micros)",
    profitTarget: "${{target}} Gewinnziel",
    maxLoss: "${{loss}} Max. Verlust",
    loadingProducts: "Produkte werden geladen...",
    errorLoading: "Fehler beim Laden der Produkte",
    noProducts: "Keine Produkte verfügbar"
  },
  testimonials: {
    badge: "Verifizierte Auszahlungen",
    title: "Tausende Trader ausgezahlt.",
    titleHighlight: "Millionen verifiziert.",
    titleEnd: "Vertrauen verdient.",
    subtitle: "Echte Trader, echte Gewinne, echte Auszahlungen. Sehen Sie die Zertifikate unserer kapitalisierten Trader weltweit.",
    certificate: {
      title: "Auszahlungszertifikat",
      fundedAccount: "Kapitalisiertes Konto",
      account: "Konto",
      trader: "Trader",
      payout: "Auszahlung",
      certificateId: "Zertifikat-ID",
      paid: "BEZAHLT"
    }
  },
  purchaseModal: {
    title: "Kauf abschließen",
    subtitle: "Sicherer Checkout-Prozess",
    resetSubtitle: "Kontostand und Statistiken zurücksetzen",
    resetDescription: "Setzen Sie Ihre Kontostatistiken und Ihren Kontostand zurück. Bitte beachten Sie, dass dieses Produkt die Laufzeit Ihres Trading-Kontos nicht verlängert.",
    extensionDescription: "Dieses Produkt verlängert Ihr Trading-Konto um weitere 30 Tage. Es hat keine Auswirkungen auf Ihre Trading-Statistiken.",
    fundedFeeDescription: "Dies ist die Aktivierungsgebühr für Ihr neues Funded-Konto und alle weiteren Funded-Konten, die in diesem Zeitraum aktiviert werden.",
    personalInformation: "Persönliche Informationen",
    personalInfoDescription: "Bitte geben Sie Ihre persönlichen Daten an",
    firstName: "Vorname",
    lastName: "Nachname",
    enterFirstName: "Geben Sie Ihren Vornamen ein",
    enterLastName: "Geben Sie Ihren Nachnamen ein",
    emailAddress: "E-Mail-Adresse",
    enterEmail: "Geben Sie Ihre E-Mail-Adresse ein",
    country: "Land",
    countryOrRegion: "Land oder Region",
    selectCountry: "Wählen Sie Ihr Land",
    searchCountries: "Länder suchen...",
    noCountriesFound: "Keine Länder gefunden",
    streetAddress: "Straßenadresse",
    address: "Adresse",
    enterStreetAddress: "Geben Sie Ihre Straßenadresse ein",
    postalCode: "Postleitzahl",
    enterPostalCode: "Geben Sie Ihre Postleitzahl ein",
    city: "Stadt",
    enterCity: "Geben Sie Ihre Stadt ein",
    challenge: "Evaluation",
    profitTarget: "Gewinnziel",
    maxDailyLoss: "Max. Tagesverlust",
    maxTotalLoss: "Max. Gesamtverlust",
    maxLoss: "Max. Verlust",
    profitSplit: "Gewinnbeteiligung",
    minTradingDays: "Min. Handelstage",
    maxLots: "Max. Kontrakte",
    continue: "Weiter",
    continueToPayment: "Weiter zur Zahlung",
    personal: "Persönlich",
    payment: "Zahlung",
    paymentDetails: "Zahlungsdetails",
    paymentInformation: "Zahlungsinformationen",
    securePayment: "Sichere Zahlungsabwicklung",
    paymentMethod: "Zahlungsmethode",
    currency: "Währung",
    card: "Karte",
    cardNumber: "Kartennummer",
    enterCardNumber: "1234 5678 9012 3456",
    expiration: "Ablaufdatum",
    enterExpiry: "MM/JJ",
    cvv: "CVV",
    enterCvv: "123",
    fullName: "Vollständiger Name",
    cardholderName: "Karteninhaber",
    enterCardholderName: "Max Mustermann",
    creditCard: "Kreditkarte",
    expiryDate: "Ablaufdatum",
    securePaymentTitle: "Sichere Zahlung",
    securePaymentDescription: "Ihre Zahlungsinformationen sind verschlüsselt und sicher.",
    paypal: "PayPal",
    paypalEmail: "PayPal-E-Mail",
    enterPaypalEmail: "ihre.email@beispiel.de",
    paypalPayment: "PayPal-Zahlung",
    paypalRedirectDescription: "Sie werden zu PayPal weitergeleitet, um Ihre Zahlung abzuschließen",
    stripeRedirectDescription: "Sie werden zu Stripe weitergeleitet, um Ihre Zahlung sicher abzuschließen",
    bitpayRedirectDescription: "Sie werden zu BitPay weitergeleitet, um Ihre Kryptowährungs-Zahlung sicher abzuschließen",
    soon: "Bald",
    crypto: "Krypto",
    cryptocurrency: "Kryptowährung",
    cryptoPayment: "Kryptowährungs-Zahlung",
    selectCryptocurrency: "Kryptowährung auswählen",
    cryptoInstructions: "Sie erhalten Zahlungsanweisungen für {cryptoType} nach Bestellbestätigung",
    cryptoImportantNote: "Bitte stellen Sie sicher, dass Sie den exakten Betrag an die angegebene Adresse senden",
    termsAndConditions: "Ich stimme den Nutzungsbedingungen und Datenschutzrichtlinien zu",
    reviewConfirm: "Überprüfen & Bestätigen",
    reviewConfirmDescription: "Bitte überprüfen Sie Ihre Bestellung vor dem Abschluss",
    orderSummary: "Bestellübersicht",
    product: "Produkt",
    price: "Preis",
    productDiscount: "Produktrabatt",
    discountedPrice: "Rabattierter Preis",
    coupon: "Gutschein",
    finalPrice: "Endpreis",
    couponCode: "Gutscheincode",
    enterCouponCode: "Gutscheincode eingeben",
    applyCoupon: "Anwenden",
    couponHelp: "Geben Sie einen gültigen Gutscheincode ein, um einen Rabatt zu erhalten",
    couponApplied: "Gutschein angewendet",
    applied: "Angewendet",
    percentDiscountApplied: "{percent}% Rabatt angewendet",
    amountDiscountApplied: "€{amount} Rabatt angewendet",
    selectDataFeed: "Datenfeed auswählen",
    targetAccount: "Ausgewähltes Konto",
    agreeToTerms: "Ich stimme den",
    termsOfService: "Nutzungsbedingungen",
    and: "und",
    privacyPolicy: "Datenschutzrichtlinie",
    noRefundPolicy: "Alle Verkäufe sind endgültig - keine Rückerstattungen",
    previous: "Zurück",
    nextStep: "Nächster Schritt",
    review: "Überprüfung",
    completePurchase: "Kauf abschließen",
    processing: "Wird verarbeitet...",
    processingPayment: "Zahlung wird verarbeitet...",
    purchaseSuccessful: "Kauf erfolgreich!",
    purchaseSuccessMessage: "Ihr Konto wurde erstellt und ist bereit zur Nutzung.",
    redirecting: "Weiterleitung...",
    paymentRedirectTitle: "Zahlungsseite ge\u00f6ffnet",
    paymentRedirectMessage: "Die Zahlungsseite wurde in einem neuen Tab ge\u00f6ffnet. Bitte schlie\u00dfe dort deine Zahlung ab.",
    paymentRedirectCloseHint: "Nach Abschluss der Zahlung kannst du dieses Fenster schlie\u00dfen.",
    paymentRedirectOpenAgain: "Zahlungslink nochmal \u00f6ffnen",
    paymentRedirectClose: "Fenster schlie\u00dfen",
    accountCreated: "Ihr Konto wurde erstellt und wird innerhalb von 24 Stunden verfügbar sein",
    subscriptionDisclaimer: "Mit dem Erstellen Ihres Abonnements erlauben Sie {productName}, Ihre Karte für diese Zahlung und zukünftige Zahlungen gemäß deren Bedingungen zu belasten. Sie können Ihr Abonnement jederzeit kündigen.",
    quantity: "Anzahl",
    cart: "Warenkorb",
    subtotal: "Zwischensumme",
    tax: "Steuer",
    total: "Gesamt",
    continueToReview: "Weiter zur Überprüfung",
    reviewAndConfirm: "Überprüfen & Bestätigen",
    tradingSystem: "Trading System",
    selectTradingSystem: "Bitte wähle einen Datenfeed aus",
    couponDiscount: "Gutscheinrabatt",
    invalidCoupon: "Der eingegebene Coupon Code existiert nicht oder ist bereits abgelaufen.",
    loadingQuote: "Preisdetails werden geladen...",
    retry: "Erneut versuchen",
    useWalletBalance: "Wallet-Guthaben verwenden",
    walletBalanceAvailable: "Verfügbar: {symbol}{amount}",
    walletCoversFullAmount: "Wallet deckt den vollen Betrag ab - keine externe Zahlung nötig",
    walletPartialCover: "Restbetrag von {symbol}{amount} wird über {method} abgerechnet",
    walletApplied: "Wallet-Guthaben",
    remainingAmount: "Restbetrag",
    volumeDiscount: "Mengenrabatt",
    volumeDiscountSavings: "Du sparst {symbol}{amount} pro Stück",
    volumeDiscountApplied: "Mengenrabatt angewendet ({percentage}% Rabatt)",
    blacklistedTitle: "Kauf nicht verfügbar",
    blacklistedMessage: "Du bist derzeit nicht berechtigt, neue Evaluations zu erwerben. Bitte kontaktiere unseren Support für weitere Details."
  },
  contactModal: {
    title: "Kontakt aufnehmen",
    subtitle: "Wir sind hier, um Ihnen zum Erfolg zu verhelfen",
    messageSentTitle: "Nachricht erfolgreich gesendet!",
    messageSentDescription: "Vielen Dank für Ihre Nachricht. Unser Team wird sich innerhalb von 24 Stunden bei Ihnen melden.",
    exploreWhileWaiting: "In der Zwischenzeit können Sie gerne unsere Plattform-Features erkunden oder sich über unseren Evaluierungsprozess informieren.",
    firstName: "Vorname",
    enterFirstName: "Geben Sie Ihren Vornamen ein",
    lastName: "Nachname",
    enterLastName: "Geben Sie Ihren Nachnamen ein",
    emailAddress: "E-Mail-Adresse",
    enterEmail: "Geben Sie Ihre E-Mail ein",
    accountNumber: "Kontonummer",
    accountNumberPlaceholder: "Ihre Kontonummer (optional)",
    subject: "Betreff",
    selectSubject: "Wählen Sie einen Betreff",
    generalInquiry: "Allgemeine Anfrage",
    evaluationProcess: "Evaluierungsprozess",
    platformSupport: "Plattform-Support",
    fundingQuestions: "Finanzierungsfragen",
    technicalSupport: "Technischer Support",
    partnership: "Partnerschaft",
    message: "Nachricht",
    messagePlaceholder: "Sagen Sie uns, wie wir Ihnen helfen können...",
    otherWaysTitle: "Weitere Kontaktmöglichkeiten",
    businessHours: "Geschäftszeiten",
    businessHoursTime: "Mo-Fr: 8:00 - 20:00 Uhr GST",
    sendingMessage: "Nachricht wird gesendet...",
    sendMessage: "Nachricht senden",
    errorSending: "Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
    overlayTitle: "Kontaktieren Sie uns per E-Mail",
    overlayDescription: "Bei Fragen, Anliegen oder wenn Sie Unterstützung benötigen, schreiben Sie uns bitte direkt eine E-Mail an:",
    overlayButton: "E-Mail senden"
  },
  partnershipModal: {
    title: "Strategische Partnerschaften",
    subtitle: "Exklusive Kooperationsmöglichkeiten",
    tabs: {
      overview: "Übersicht",
      brandAmbassador: "Markenbotschafter",
      exclusiveContracts: "Exklusive Verträge"
    },
    overview: {
      heroTitle: "Werden Sie unser",
      heroTitleHighlight: "Partner",
      heroTitleEnd: "und wachsen Sie mit uns",
      heroDescription: "Entdecken Sie unsere Partnerschaftsprogramme, die auf Ihre Bedürfnisse zugeschnitten sind, egal ob Sie ein Influencer oder ein etabliertes Unternehmen sind.",
      brandAmbassador: {
        title: "Markenbotschafter",
        subtitle: "Content Creator Programm",
        description: "Perfekt für Influencer, Coaches und Content-Ersteller, die unsere Plattform ihrer Zielgruppe vorstellen möchten.",
        benefits: {
          customCodes: "Individuelle Empfehlungscodes und Tracking",
          exclusiveContent: "Zugang zu exklusiven Marketing-Inhalten",
          prioritySupport: "Priorisierter Kundensupport",
          marketingCollaboration: "Direkte Marketing-Kooperationsmöglichkeiten"
        }
      },
      exclusiveContracts: {
        title: "Exklusive Verträge",
        subtitle: "Unternehmenspartnerschaften",
        description: "Maßgeschneiderte Vereinbarungen für etablierte Unternehmen, Handelsfirmen und Branchenprofis, die eine tiefere Zusammenarbeit suchen.",
        benefits: {
          customProfitSplits: "Verhandelte individuelle Gewinnbeteiligungsmodelle",
          dedicatedManager: "Persönlicher Account Manager und Support-Team",
          whiteLabelSolutions: "White-Label-Plattform- und Branding-Optionen",
          revenueSharingModels: "Fortgeschrittene Umsatzbeteiligungs- und Partnerschaftsmodelle"
        }
      },
      keyBenefits: {
        title: "Wichtige Vorteile unserer Partnerschaften",
        higherCommissions: {
          title: "Höhere Provisionen",
          description: "Profitieren Sie von branchenführenden Provisionssätzen und Bonusstrukturen."
        },
        dedicatedSupport: {
          title: "Dedizierter Support",
          description: "Erhalten Sie persönlichen Support von unserem Partner-Management-Team."
        },
        globalReach: {
          title: "Globale Reichweite",
          description: "Erweitern Sie Ihre Marke mit unserer internationalen Präsenz."
        }
      }
    },
    brandAmbassador: {
      heroTitle: "Werden Sie unser",
      heroTitleHighlight: "Markenbotschafter",
      heroDescription: "Als Markenbotschafter repräsentieren Sie Nextproptrader und profitieren von exklusiven Vorteilen und Provisionen.",
      requirements: {
        title: "Anforderungen an Markenbotschafter",
        audienceSize: {
          title: "Engagierte Zielgruppe",
          description: "Nachweis einer aktiven und engagierten Online-Präsenz."
        },
        contentQuality: {
          title: "Hochwertiger Inhalt",
          description: "Erstellung relevanter und ansprechender Inhalte für Trader."
        },
        engagementRate: {
          title: "Hohe Engagement-Rate",
          description: "Starke Interaktion mit Ihrer Community."
        },
        brandAlignment: {
          title: "Markenübereinstimmung",
          description: "Ihre Werte stimmen mit denen von Nextproptrader überein."
        }
      },
      exclusiveBenefits: {
        title: "Exklusive Vorteile",
        customReferralCodes: {
          title: "Individuelle Empfehlungscodes",
          description: "Personalisierte Codes für Ihre Zielgruppe."
        },
        exclusiveContent: {
          title: "Exklusive Marketing-Inhalte",
          description: "Zugang zu speziellen Bannern, Videos und Texten."
        },
        marketingMaterials: {
          title: "Umfassende Marketingmaterialien",
          description: "Professionelle Ressourcen zur Unterstützung Ihrer Promotion."
        },
        directCommunication: {
          title: "Direkte Kommunikation",
          description: "Direkter Draht zu unserem Partner-Management-Team."
        }
      }
    },
    exclusiveContracts: {
      heroTitle: "für",
      heroTitleHighlight: "Exklusive Verträge",
      heroDescription: "Maßgeschneiderte Partnerschaften für Unternehmen und Branchenführer, die eine tiefere Integration und Zusammenarbeit wünschen.",
      professionals: {
        title: "Professionelle Trader",
        subtitle: "Individuelle Vereinbarungen",
        description: "Für erfahrene Trader, die mit unserem Kapital handeln und von maßgeschneiderten Konditionen profitieren möchten.",
        benefits: {
          customProfitSplit: "Individuelle Gewinnbeteiligung",
          accessToAlgorithms: "Zugang zu proprietären Algorithmen",
          tradeWithTeam: "Handel mit unserem Team",
          profitFromCapital: "Profitieren Sie von unserem Kapital"
        }
      },
      industryLeaders: {
        title: "Branchenführer",
        subtitle: "Strategische Allianzen",
        description: "Für Unternehmen, die eine White-Label-Lösung oder eine tiefere strategische Partnerschaft suchen.",
        benefits: {
          revenueSharing: "Umsatzbeteiligungsmodelle",
          whiteLabelOptions: "White-Label-Optionen",
          coMarketingOpportunities: "Co-Marketing-Möglichkeiten",
          customBrandingSolutions: "Individuelle Branding-Lösungen"
        }
      }
    },
    contact: {
      title: "Interessiert an einer Partnerschaft?",
      description: "Kontaktieren Sie uns, um mehr über unsere maßgeschneiderten Partnerschaftsprogramme zu erfahren und wie wir gemeinsam wachsen können.",
      button: "Kontakt aufnehmen"
    }
  },
  affiliateModal: {
    title: "Affiliate-Programm",
    subtitle: "Verdienen Sie Provision bei jeder Empfehlung",
    tabs: {
      overview: "Übersicht",
      benefits: "Vorteile",
      requirements: "Anforderungen"
    },
    overview: {
      heroTitle: "Verdienen Sie",
      heroTitleHighlight: "10-25% Provision",
      heroTitleEnd: "bei jedem Verkauf",
      heroDescription: "Treten Sie unserem Affiliate-Programm bei und verdienen Sie erhebliche Provisionen, während Sie Tradern dabei helfen, professionelle Finanzierung zu erhalten. Ihre Empfehlungen erhalten auch exklusive Rabatte!",
      features: {
        highCommissions: {
          title: "Hohe Provisionen",
          subtitle: "Bei allen Evaluierungskäufen",
          description: "Verdienen Sie 10-25% Provision bei jedem Kauf über Ihren Empfehlungslink oder Gutscheincode. Keine Obergrenze, keine Limits - je mehr Sie empfehlen, desto mehr verdienen Sie."
        },
        customerDiscounts: {
          title: "Kundenrabatte",
          subtitle: "Ihre Empfehlungen sparen Geld",
          description: "Ihre empfohlenen Kunden erhalten exklusive Rabatte auf ihre Evaluierungen, was eine Win-Win-Situation für alle Beteiligten schafft."
        }
      },
      commissionCalculator: {
        title: "Provisions-Rechner",
        sales: "Verkäufe",
        proPlan: "€169 Pro Plan",
        mixedPlans: "Gemischte Pläne",
        averagePlan: "Durchschnitt €169",
        monthlyGoal: "Monatsziel"
      },
      partnershipRewards: {
        title: "Langfristige Partnerschaftsbelohnungen",
        description: "Für erfolgreiche langfristige Affiliate-Partnerschaften teilen wir auch einen Prozentsatz der Gewinne von den erfolgreichen Tradern, die Sie uns empfehlen.",
        features: {
          traderSuccess: {
            title: "Trader-Erfolg",
            description: "Anteil an Trader-Gewinnen"
          },
          partnership: {
            title: "Partnerschaft",
            description: "Langfristige Zusammenarbeit"
          },
          passiveIncome: {
            title: "Passives Einkommen",
            description: "Zusätzliche Einnahmequelle"
          }
        },
        premiumBenefits: {
          title: "Premium-Partnerschaftsvorteile",
          description: "Qualifizierte Partner erhalten zusätzlich zu den 10% Provisionen einen Anteil an den laufenden Gewinnen ihrer erfolgreich empfohlenen Trader."
        }
      }
    },
    benefits: {
      highConversion: {
        title: "Hohe Conversion-Raten",
        description: "Unser bewährter Evaluierungsprozess und wettbewerbsfähige Preise führen zu ausgezeichneten Conversion-Raten für Ihre Empfehlungen."
      },
      premiumBrand: {
        title: "Premium-Marke",
        description: "Bewerben Sie ein vertrauenswürdiges, professionelles Prop-Trading-Unternehmen mit ausgezeichnetem Ruf in der Branche."
      },
      bonusPayments: {
        title: "Bonus-Zahlungen",
        description: "Zusätzlich zu Provisionserhöhungen erhalten Sie auch regelmäßige Bonus-Zahlungen."
      },
      marketingSupport: {
        title: "Marketing-Unterstützung",
        description: "Zugang zu professionellen Marketing-Materialien, Bannern und Inhalten, um Ihnen bei der effektiven Bewerbung zu helfen."
      },
      realTimeTracking: {
        title: "Echtzeit-Tracking",
        description: "Überwachen Sie Ihre Empfehlungen, Conversions und Einnahmen in Echtzeit über Ihr Affiliate-Dashboard."
      },
      customerBenefits: {
        title: "Kundenvorteile",
        description: "Ihre Empfehlungen erhalten exklusive Rabatte, was es einfacher macht, Interessenten in Kunden zu verwandeln."
      },
      payoutInfo: {
        title: "Auszahlungsinformationen",
        frequency: {
          value: "Monatlich",
          label: "Auszahlungsfrequenz"
        },
        minimum: {
          value: "€50",
          label: "Mindestablösung"
        },
        methods: {
          value: "Mehrere",
          label: "Zahlungsmethoden"
        }
      }
    },
    requirements: {
      title: "Affiliate-Anforderungen",
      nptAccount: {
        subtitle: "Konto erforderlich",
        description: "Du ben\u00f6tigst ein Nextproptrader Konto, welches du entweder durch den Beginn einer Evaluation erstellt hast oder unten \u00fcber den Registrieren Button erstellen kannst."
      },
      marketingCompliance: {
        title: "Marketing-Compliance",
        description: "Stimmen Sie zu, unsere Marketing-Richtlinien zu befolgen und unsere Marke professionell zu repr\u00e4sentieren."
      },
      existingAccountInfo: "Wenn du bereits ein Nextproptrader Konto hast, musst du dich nicht neu registrieren. Du kannst deinen bestehenden Account auch f\u00fcr das Affiliate-Programm nutzen \u2013 logge dich einfach ein und navigiere im Men\u00fc zur Affiliate-Seite.",
      readyToJoin: {
        title: "Bereit beizutreten?",
        description: "Jeder Nextproptrader-Kontoinhaber nimmt automatisch an unserem Affiliate-Programm teil.",
        loginButton: "Einloggen",
        createAccountButton: "Konto erstellen"
      },
      register: {
        title: "Konto erstellen",
        firstnameLabel: "Vorname",
        firstnamePlaceholder: "Max",
        lastnameLabel: "Nachname",
        lastnamePlaceholder: "Mustermann",
        emailLabel: "E-Mail-Adresse",
        emailPlaceholder: "deine@email.com",
        passwordLabel: "Passwort",
        passwordPlaceholder: "Sicheres Passwort w\u00e4hlen",
        confirmPasswordLabel: "Passwort wiederholen",
        confirmPasswordPlaceholder: "Passwort erneut eingeben",
        passwordMismatch: "Die Passw\u00f6rter stimmen nicht \u00fcberein.",
        submitButton: "Konto erstellen",
        submitting: "Wird erstellt...",
        successTitle: "Konto erfolgreich verifiziert!",
        successDescription: "Deine E-Mail wurde verifiziert und dein Konto ist jetzt aktiv. Du kannst dich einloggen und im Dashboard zur Affiliate-Seite navigieren.",
        genericError: "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
        verifyTitle: "E-Mail verifizieren",
        verifyDescription: "Wir haben dir eine Verifizierungs-E-Mail gesendet. Gib den Code aus der E-Mail ein oder klicke auf den Link in der E-Mail, um dein Konto zu verifizieren.",
        codeLabel: "Verifizierungscode",
        codePlaceholder: "123456",
        codeRequired: "Bitte gib den Verifizierungscode ein.",
        verifyButton: "Verifizieren",
        verifying: "Wird verifiziert...",
        verifyError: "Verifizierung fehlgeschlagen. Bitte \u00fcberpr\u00fcfe deinen Code und versuche es erneut.",
        verifyHint: "Keine E-Mail erhalten? Pr\u00fcfe deinen Spam-Ordner oder gehe zur\u00fcck, um dich erneut zu registrieren."
      }
    }
  },

  verifyRegistration: {
    title: "Registrierung verifizieren",
    subtitle: "Konto-Verifizierung",
    verifying: "Dein Konto wird verifiziert...",
    success: "Dein Konto wurde verifiziert!",
    successDetail: "Deine E-Mail wurde best\u00e4tigt und dein Konto ist jetzt aktiv. Du kannst dich einloggen und Nextproptrader nutzen.",
    error: "Verifizierung fehlgeschlagen. Der Link ist m\u00f6glicherweise ung\u00fcltig oder abgelaufen.",
    tryCode: "Verifizierungscode stattdessen manuell eingeben",
    codeTitle: "Verifizierungscode eingeben",
    codeDescription: "Gib den Verifizierungscode aus der E-Mail ein, die wir dir geschickt haben, um deine Registrierung abzuschlie\u00dfen.",
    emailLabel: "E-Mail-Adresse",
    emailPlaceholder: "deine@email.com",
    codeLabel: "Verifizierungscode",
    codePlaceholder: "123456",
    allFieldsRequired: "Bitte f\u00fclle alle Felder aus.",
    verifyButton: "Konto verifizieren",
    verifyingButton: "Wird verifiziert...",
    backToHome: "Zur\u00fcck zur Startseite"
  },

  verifyPayment: {
    subtitle: "Zahlungsverifizierung",
    verifying: "Zahlung wird \u00fcberpr\u00fcft...",
    verifyingDetail: "Wir pr\u00fcfen deinen Zahlungsstatus. Dies kann einen Moment dauern.",
    success: "Zahlung erfolgreich!",
    successDetail: "Deine Zahlung wurde best\u00e4tigt. Dein Konto wird eingerichtet und ist in K\u00fcrze verf\u00fcgbar.",
    failed: "Zahlung fehlgeschlagen",
    failedDetail: "Deine Zahlung konnte nicht verarbeitet werden. Bitte versuche es erneut oder kontaktiere den Support.",
    expired: "Zahlungslink abgelaufen",
    expiredDetail: "Dieser Zahlungslink ist abgelaufen. Bitte starte einen neuen Checkout, um deinen Kauf abzuschlie\u00dfen.",
    timeout: "Verifizierung dauert l\u00e4nger als erwartet",
    timeoutDetail: "Deine Zahlung wird m\u00f6glicherweise noch verarbeitet. Du kannst es erneut versuchen oder deine E-Mails auf eine Best\u00e4tigung pr\u00fcfen.",
    retry: "Erneut pr\u00fcfen",
    backToHome: "Zur\u00fcck zur Startseite",
    closeTab: "Tab schlie\u00dfen"
  },
  whiteLabelModal: {
    title: "White Label Lösung",
    subtitle: "Komplette Infrastruktur und Technologie-Plattform",
    heroTitle: "Starten Sie Ihre eigene Prop-Trading-Firma",
    heroDescription: "Erhalten Sie eine vollständig gebrandete, schlüsselfertige Prop-Trading-Plattform unter Ihrem eigenen Namen. Unsere White-Label-Lösung bietet alles, was Sie für ein professionelles Prop-Trading-Geschäft benötigen — von der Trader-Evaluierung bis zum Funded-Account-Management.",
    features: {
      customBranding: {
        title: "Individuelles Branding",
        description: "Vollständige Branding-Anpassung einschließlich Logo, Farben, Schriften und Designelemente, die zu Ihrer Corporate Identity passen."
      },
      ownDomain: {
        title: "Eigene Domain",
        description: "Betreiben Sie Ihre Plattform auf Ihrer eigenen Domain mit benutzerdefinierten SSL-Zertifikaten für ein nahtloses, professionelles Erlebnis."
      },
      fullControl: {
        title: "Volle Kontrolle",
        description: "Verwalten Sie Trader, Konten, Auszahlungen und Regeln unabhängig mit einem leistungsstarken Admin-Dashboard."
      },
      cloudHosting: {
        title: "Cloud-Hosting",
        description: "Enterprise-Cloud-Infrastruktur mit globalem CDN, automatischer Skalierung und 99,9% Verfügbarkeitsgarantie."
      },
      apiAccess: {
        title: "API-Zugang",
        description: "Umfassende REST-API für nahtlose Integration mit Ihren bestehenden Systemen und Drittanbieter-Diensten."
      },
      customization: {
        title: "Flexible Anpassung",
        description: "Konfigurieren Sie Evaluierungsregeln, Gewinnaufteilung, Kontogrössen und Handelsparameter passend zu Ihrem Geschäftsmodell."
      }
    },
    whyChoose: {
      title: "Warum White Label?",
      setup: {
        value: "< 2 Wochen",
        label: "Einrichtungszeit"
      },
      uptime: {
        value: "99,9%",
        label: "Verfügbarkeitsgarantie"
      },
      support: {
        value: "24/7",
        label: "Technischer Support"
      }
    },
    contact: {
      title: "Bereit für Ihre White Label Lösung?",
      description: "Kontaktieren Sie unser Team, um Ihre White Label Anforderungen zu besprechen und eine maßgeschneiderte Lösung für Ihre Geschäftsanforderungen zu erhalten.",
      button: "White Label Team kontaktieren"
    }
  },
  affiliateStatus: {
    enroll: {
      title: "Affiliate-Programm beitreten",
      subtitle: "Werde Partner von Nextproptrader",
      description: "Wenn du am Affiliate-Programm von Nextproptrader teilnehmen möchtest, kannst du dich hier ganz einfach registrieren. Mit der Anmeldung bestätigst du, dass du unsere Nutzungsbedingungen, die Datenschutzbestimmungen sowie die Affiliate-Richtlinien gelesen hast und akzeptierst \u2013 erst danach ist eine Teilnahme möglich.",
      benefits: "Als Affiliate erwartet dich ein leistungsstarkes Partner-Dashboard mit vollständigem Tracking (Klicks, Leads, Sales in Echtzeit), individuellen Affiliate-Links sowie der Möglichkeit, eigene Coupon-Codes zu erstellen. Du profitierst von großzügigen Provisionen, optionalen Bonuszahlungen und flexiblen Auszahlungsoptionen \u2013 darunter Banküberweisung, PayPal oder Krypto (je nach Verfügbarkeit/Option im System).",
      button: "Jetzt registrieren",
      enrolling: "Registrierung läuft...",
      trackingTitle: "Echtzeit-Tracking",
      trackingDesc: "Klicks, Leads & Sales live verfolgen",
      linksTitle: "Individuelle Links",
      linksDesc: "Eigene Affiliate-Links & Coupon-Codes",
      commissionsTitle: "Provisionen",
      commissionsDesc: "Großzügige Vergütung & Bonuszahlungen",
      payoutsTitle: "Flexible Auszahlung",
      payoutsDesc: "Bank, PayPal oder Krypto"
    },
    suspended: {
      title: "Konto gesperrt",
      description: "Ihr Affiliate-Konto wurde gesperrt. Sie haben keinen Zugriff mehr auf das Affiliate-Programm.",
      support: "Wenn Sie glauben, dass dies ein Fehler ist oder weitere Informationen wünschen, wenden Sie sich bitte an unser Support-Team zur Klärung.",
      contactSupport: "Support kontaktieren"
    },
    pending: {
      title: "Affiliate-Registrierung abschließen",
      subtitle: "AGBs akzeptieren und Partnerprofil einrichten",
      step1: "AGBs akzeptieren",
      step2: "Partner Name",
      loading: "Lade Vereinbarungen",
      loadingDescription: "Bereite deine Affiliate-Registrierung vor...",
      termsTitle: "Affiliate-Programm Allgemeine Geschäftsbedingungen",
      acceptTerms: "Ich habe die Allgemeinen Geschäftsbedingungen des Affiliate-Programms gelesen und akzeptiere sie",
      continue: "Weiter zu Schritt 2",
      nameTitle: "Partner-Namen festlegen",
      nameDescription: "Wählen Sie einen Anzeigenamen, der in Ihren Affiliate-Materialien und Berichten angezeigt wird",
      partnerName: "Partner Anzeigename",
      partnerNamePlaceholder: "Partner-Namen eingeben...",
      back: "Zurück",
      complete: "Registrierung abschließen",
      submitting: "Wird abgeschlossen..."
    },
    complete: {
      title: "Registrierung abgeschlossen",
      description: "Dein Affiliate-Konto wird aktiviert. Diese Seite aktualisiert sich automatisch."
    }
  },
  months: {
    january: "Januar",
    february: "Februar",
    march: "März",
    april: "April",
    may: "Mai",
    june: "Juni",
    july: "Juli",
    august: "August",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Dezember"
  },
  partnerLanding: {
    backToMainSite: "Zurück zur Hauptseite",
    officialPartner: "Offizieller Partner",
    heroDescription: "Erhalten Sie exklusiven Zugang zu professionellem Prop-Trading mit speziellen Partner-Vorteilen. Starten Sie Ihre Trading-Reise mit",
    profitSplit: "100% Gewinnbeteiligung",
    noHiddenFees: "und ohne versteckte Gebühren.",
    benefits: {
      exclusiveDiscounts: {
        title: "Exklusive Rabatte",
        description: "Spezielle Preise nur verfügbar über {partner}"
      },
      profitSplit: {
        title: "100% Gewinnbeteiligung",
        description: "Behalten Sie alles, was Sie verdienen - keine versteckten Kürzungen"
      },
      premiumSupport: {
        title: "Premium Support",
        description: "Prioritäts-Support als Partner-Empfehlung"
      }
    },
    startEvaluation: "Starten Sie Ihre Evaluierung",
    whyChoose: "Warum",
    whyChooseBadge: "Unsere Vorteile",
    recommendedBy: "Empfohlen von {partner} für ernsthafte Trader, die echte Ergebnisse wollen",
    features: {
      profitSplit: {
        title: "100% Gewinnbeteiligung",
        description: "Behalten Sie alles, was Sie verdienen. Keine versteckten Kürzungen oder Gebühren."
      },
      dailyPayouts: {
        title: "Tägliche Auszahlungen",
        description: "Greifen Sie sofort auf Ihre Gewinne zu, nicht erst Wochen später."
      },
      transparentRules: {
        title: "Transparente Regeln",
        description: "Klare, faire Regeln ohne überraschende Einschränkungen."
      },
      noTimePressure: {
        title: "Kein Zeitdruck",
        description: "Handeln Sie in Ihrem eigenen Tempo - keine Mindest-Handelstage erforderlich."
      }
    },
    pricing: {
      exclusiveBadge: "EXKLUSIVE PARTNER-PREISE",
      title: "Spezielle Preise für",
      community: "Community",
      description: "Erhalten Sie exklusive Rabatte und starten Sie noch heute mit unserem Kapital. Zeitlich begrenztes Angebot!"
    },
    testimonial: {
      title: "Vertraut von",
      quote: "{partner} hat Nextproptrader sorgfältig als bevorzugte Prop-Trading-Firma für unsere Community ausgewählt. Mit ihrer 100% Gewinnbeteiligung und transparenten Herangehensweise passen sie perfekt zu unseren Werten, Tradern zum Erfolg zu verhelfen.",
      stats: {
        profitSplit: "Gewinnbeteiligung",
        daily: "Täglich",
        payouts: "Auszahlungen",
        oneDay: "5 Tage",
        minEvaluation: "Min. Evaluierung"
      }
    },
    howItWorks: {
      badge: "So Funktioniert's",
      title: "So",
      titleHighlight: "Funktioniert's",
      subtitle: "Einfacher 3-Schritte-Prozess zum Funding und Verdienen",
      steps: {
        step1: {
          title: "Wählen Sie Ihren Plan",
          description: "Wählen Sie die Kontogröße, die zu Ihrem Trading-Stil passt und erhalten Sie exklusive Partner-Rabatte."
        },
        step2: {
          title: "Evaluierung Bestehen",
          description: "Erreichen Sie Ihr Gewinnziel bei angemessenem Risikomanagement - kein Zeitdruck."
        },
        step3: {
          title: "Finanzierung Erhalten & Bezahlt Werden",
          description: "Erhalten Sie Ihr finanziertes Konto und beginnen Sie zu verdienen mit 100% Gewinnbeteiligung und täglichen Auszahlungen."
        }
      }
    },
    finalCta: {
      title: "Bereit, mit",
      titleHighlight: "Unserem Kapital zu Handeln?",
      description: "Schließen Sie sich Tausenden erfolgreichen Tradern an, die Nextproptrader vertrauen. Starten Sie noch heute mit exklusiven {partner} Preisen.",
      viewPricing: "Partner-Preise Ansehen",
      learnMore: "Mehr über Nextproptrader Erfahren"
    }
  },
  kyc: {
    title: "Identitätsverifizierung",
    subtitle: "KYC-Verifizierung",
    introTitle: "Identität bestätigen",
    introDescription: "Bevor Sie eine Auszahlung anfordern können, müssen wir Ihre Identität verifizieren. Dies ist ein einmaliger Vorgang, der gemäß regulatorischen Standards erforderlich ist, um die Sicherheit Ihres Kontos und Ihrer Gelder zu gewährleisten.",
    introStep1: "Geburtsdatum angeben",
    introStep2: "Staatsangehörigkeit und Wohnsitzland bestätigen",
    introStep3: "Gültiges amtliches Ausweisdokument hochladen",
    introNote: "Ihre Daten werden verschlüsselt und sicher gespeichert. Wir verwenden sie ausschließlich zu Verifizierungszwecken gemäß geltender Vorschriften.",
    startVerification: "Verifizierung starten",
    stepPersonal: "Persönliche Daten",
    stepDocument: "Dokument",
    stepReview: "Überprüfung",
    personalInfoTitle: "Persönliche Informationen",
    personalInfoDesc: "Bitte geben Sie Ihre persönlichen Daten genau so an, wie sie auf Ihrem amtlichen Ausweisdokument stehen.",
    dateOfBirth: "Geburtsdatum",
    nationality: "Staatsangehörigkeit",
    residenceCountry: "Wohnsitzland",
    searchCountry: "Land suchen...",
    continue: "Weiter",
    documentTitle: "Ausweisdokument",
    documentDesc: "Laden Sie ein deutliches Foto oder einen Scan Ihres amtlichen Ausweisdokuments hoch.",
    acceptedDocuments: "Akzeptierte Dokumente",
    docPassport: "Gültiger Reisepass",
    docIdCard: "Personalausweis",
    docRequirements: "JPG, PNG, WebP oder PDF. Max. 10 MB. Stellen Sie sicher, dass das Dokument gut lesbar und alle Details erkennbar sind.",
    dragOrClick: "Klicken zum Hochladen oder Datei hierher ziehen",
    supportedFormats: "JPG, PNG, WebP, PDF - max. 10 MB",
    clickToChange: "Klicken um Datei zu ändern",
    uploadDocument: "Hochladen & Weiter",
    back: "Zurück",
    reviewTitle: "Ihre Angaben überprüfen",
    reviewDesc: "Bitte überprüfen Sie, ob alle Angaben korrekt sind, bevor Sie absenden.",
    documentUploaded: "Dokument",
    documentReady: "Dokument hochgeladen",
    reviewWarning: "Bitte stellen Sie sicher, dass alle Angaben genau mit Ihren offiziellen Dokumenten übereinstimmen. Fehlerhafte Angaben können den Verifizierungsprozess verzögern.",
    submitVerification: "Verifizierung absenden",
    successTitle: "Verifizierung eingereicht",
    successDescription: "Ihre Identitätsverifizierung wurde erfolgreich eingereicht. Unser Team wird Ihre Dokumente prüfen und Sie werden benachrichtigt, sobald der Vorgang abgeschlossen ist.",
    processingTime: "Bearbeitungszeit: bis zu 48 Stunden",
    pendingTitle: "Verifizierung in Bearbeitung",
    pendingDescription: "Ihre Identitätsverifizierung wird derzeit von unserem Team geprüft. Sie werden benachrichtigt, sobald die Prüfung abgeschlossen ist. Dies dauert in der Regel bis zu 48 Stunden.",
    close: "Schließen",
    errorStarting: "Verifizierung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
    errorSaving: "Daten konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.",
    errorSubmitting: "Verifizierung konnte nicht eingereicht werden. Bitte versuchen Sie es erneut.",
    uploadFailed: "Dokument konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.",
    invalidFileType: "Ungültiger Dateityp. Bitte laden Sie eine JPG-, PNG-, WebP- oder PDF-Datei hoch.",
    fileTooLarge: "Datei ist zu groß. Maximale Größe beträgt 10 MB.",
    rejectedTitle: "Verifizierung abgelehnt",
    rejectedDescription: "Leider wurde Ihre Identitätsverifizierung abgelehnt. Bitte lesen Sie den Grund unten und starten Sie den Prozess erneut mit korrekten Angaben.",
    rejectionReasonLabel: "Grund der Ablehnung",
    rejectedHint: "Sie können den Verifizierungsprozess erneut starten. Bitte stellen Sie sicher, dass alle Angaben korrekt sind und Ihre Dokumente gut lesbar sind.",
    restartVerification: "Verifizierung erneut starten"
  },
  countdown: {
    comingSoon: "Demnachst Verfugbar",
    liveNow: "Wir Sind Live",
    description: "Etwas Grosses ist auf dem Weg. Mach dich bereit fur eine neue Ara des Prop Tradings.",
    liveDescription: "Das Warten hat ein Ende. Willkommen in der Zukunft des Prop Tradings.",
    days: "Tage",
    hours: "Stunden",
    minutes: "Minuten",
    seconds: "Sekunden",
    launchDate: "1. April 2026 - 08:00 UTC",
    enterCode: "Zugangscode..."
  },
  affiliatePage: {
    nav: {
      home: "Startseite",
      apply: "Jetzt kostenlos beantragen"
    },
    hero: {
      badge: "NEXTPROPTRADER AFFILIATE PROGRAM",
      headline: "Verdiene mit jedem Trader, den du empfiehlst.",
      subline: "Werde Affiliate-Partner von Nextproptrader und baue dir mit einem starken Produkt, attraktiven Provisionen und Bonus-Stufen ein skalierbares Einkommen auf.",
      cta1: "Jetzt kostenlos beantragen",
      cta2: "Berechne dein Affiliate Potential",
      trust1: "25% Affiliate Provision",
      trust2: "Beste Konditionen",
      trust3: "100% Payout für deine Community",
      trust4: "Einzigartige Bonis",
      dashboardTitle: "Affiliate Dashboard",
      dashboardLive: "Live",
      dashboardClicks: "Klicks",
      dashboardOrders: "Orders",
      dashboardConversion: "Conversion",
      dashboardCommission: "Provision gesamt",
      dashboardTier: "Aktuelles Level",
      dashboardRecentSales: "Letzte Verkäufe"
    },
    stats: {
      funded: "Finanziertes Kapital",
      traders: "Aktive Trader",
      commission: "Affiliate-Provision",
      bonus: "Einmalbonus möglich"
    },
    why: {
      headline: "Warum Nextproptrader promoten?",
      cards: [
        {
          title: "Ein Produkt, das Trader überzeugt",
          text: "Nextproptrader bietet 100% Gewinnbeteiligung, tägliche Auszahlungen und faire Evaluierungen — ein Angebot, das in der Prop-Trading-Branche heraussticht."
        },
        {
          title: "Attraktive Provisionsstruktur",
          text: "Starte mit 10% und wachse bis zu 25% Provision pro Sale. Jede Empfehlung zahlt sich direkt aus — ohne Volumenbegrenzung."
        },
        {
          title: "Einmalige Bonus-Stufen",
          text: "Beim Erreichen bestimmter Meilensteine schaltest du zusätzliche Einmalboni frei — bis zu €10.000 je Stufe."
        },
        {
          title: "Transparentes Live-Dashboard",
          text: "Verfolge Klicks, Conversions und deine Provision in Echtzeit. Vollständige Transparenz über deine Performance — jederzeit, überall."
        }
      ]
    },
    tiers: {
      headline: "Dein Weg. Deine Provision.",
      subline: "Starte als Affiliate und entwickle dich Schritt für Schritt in höhere Provisionsklassen.",
      commissionLabel: "Provision",
      bonusLabel: "Einmalbonus",
      salesLabel: "ab Sales",
      overviewLabel: "Stufen-Übersicht",
      startLevel: "Startlevel",
      fromSales: "ab {n} Sales",
      tierOf: "Stufe {current} / {total}",
      noMinimum: "Kein Minimum",
      noMinRevenue: "Kein Mindestumsatz",
      confirmedSales: "Ab {n} bestätigten Sales",
      maxCommission: "Max. Provision",
      descriptions: {
        starter: "Ideal zum Einstieg. Starte ohne Mindestanforderungen und verdiene sofort mit deinen ersten Empfehlungen. Keine Bewerbung, kein Mindestumsatz.",
        bronze: "Dein erster Meilenstein. Mit 50 erfolgreichen Sales schaltest du einen Einmalbonus frei und beweist, dass deine Audience konvertiert.",
        silber: "Solide Performance. Bei 150 Sales wächst dein Bonus auf €2.500 — ein klares Signal, dass dein Kanal echten Wert liefert.",
        gold: "Höhere Provision. Ab 300 Sales steigt deine Provision auf 15% — mehr Verdienst auf denselben Empfehlungen, automatisch.",
        platin: "Starke Reichweite. 500 Sales bedeuten ein bewährtes Empfehlungsmodell — belohnt mit einem Einmalbonus von €5.000.",
        diamant: "Top-Performance. Du hast eine skalierbare Affiliate-Maschine aufgebaut. Dein Einmalbonus: €10.000.",
        elite: "Elite-Status. Nur die stärksten Affiliates erreichen diese Stufe — mit 25% Provision auf jeden Sale und unbegrenztem Potenzial."
      }
    },
    calc: {
      headline: "Berechne dein Affiliate Potential",
      subline: "Erhalte einen groben Richtwert, wie viel Provision mit deiner Reichweite möglich sein könnte.",
      disclaimer: "Die Berechnung dient nur als grober Richtwert und basiert auf Annahmen zu Conversion und Durchschnittsbestellwert.",
      followerLabel: "Deine Abonnenten / Follower",
      conversionLabel: "Geschätzte Conversion Rate",
      salesOutput: "Geschätzte Sales",
      revenueOutput: "Geschätzter Umsatz",
      commissionOutput: "Geschätzte Provision",
      tierOutput: "Aktuelle Stufe",
      progressLabel: "Sales bis zur nächsten Stufe",
      bonusNote: "Bei Erreichen dieser Stufe ist zusätzlich ein Einmalbonus von",
      bonusNote2: "möglich.",
      cta: "Jetzt kostenlos beantragen",
      basisLabel: "Berechnungsgrundlage",
      estimatedBuyers: "Geschätzte Käufer",
      avgOrderValue: "Ø Bestellwert",
      commissionShort: "Provision",
      perMonthEstimate: "pro Monat (Schätzung)",
      footerNote: "Schätzung basiert auf historischen Durchschnittswerten. Individuelle Ergebnisse können abweichen.",
      eliteReached: "Elite-Status erreicht",
      eliteMax: "Maximale Provision von 25%"
    },
    steps: {
      headline: "So funktioniert's",
      items: [
        {
          title: "Kostenlos registrieren",
          text: "Bewirb dich für das Affiliate-Programm und erhalte nach Freischaltung sofortigen Zugang zu deinem persönlichen Tracking-Link."
        },
        {
          title: "Affiliate-Link teilen",
          text: "Integriere deinen Link in Videos, Newsletter, Social-Media-Beiträge oder deine Website — und erreiche deine Zielgruppe dort, wo sie aktiv ist."
        },
        {
          title: "Provisionen verdienen",
          text: "Für jeden erfolgreichen Kauf über deinen Link erhältst du deine Provision. Mit wachsender Performance steigst du automatisch in höhere Stufen auf."
        }
      ]
    },
    faq: {
      headline: "Häufige Fragen",
      items: [
        {
          q: "Wie hoch ist die Provision?",
          a: "Die Provision startet bei 10 % (Starter-Stufe) und kann mit wachsender Performance bis auf 25 % (Elite-Stufe) ansteigen. Zusätzlich gibt es bei bestimmten Stufen einmalige Boni von bis zu €10.000."
        },
        {
          q: "Wann werde ich ausgezahlt?",
          a: "Die genauen Auszahlungsmodalitäten werden im Rahmen des Onboardings kommuniziert. Wir arbeiten an einem transparenten, zuverlässigen Auszahlungsprozess für alle Partner."
        },
        {
          q: "Gibt es Mindestanforderungen?",
          a: "Für die Bewerbung gibt es keine Mindest-Followerzahl oder Umsatzschwelle. Jeder, der eine relevante Zielgruppe im Trading- oder Finance-Bereich anspricht, kann sich bewerben."
        },
        {
          q: "Wie lange ist der Cookie gültig?",
          a: "Die Tracking-Cookie-Laufzeit wird im Partnerprogramm-Dashboard kommuniziert. In der Regel ermöglicht ein längeres Cookie-Window höhere Konversionsraten für deine Empfehlungen."
        },
        {
          q: "Kann ich mehrere Links erstellen?",
          a: "Ja. Im Affiliate-Dashboard kannst du mehrere Tracking-Links für verschiedene Kanäle, Kampagnen oder Inhalte anlegen und deren Performance separat verfolgen."
        }
      ]
    },
    cta: {
      headline: "Bereit, mit Nextproptrader als Affiliate zu wachsen?",
      subline: "Bewirb dich kostenlos und sichere dir Zugang zum Affiliate-Programm.",
      button: "Jetzt kostenlos beantragen",
      support: "Kostenlos. Unverbindlich. Schneller Start."
    },
    footer: {
      copy: "© 2024 Nextproptrader. Alle Rechte vorbehalten.",
      program: "Affiliate Program"
    }
  }
};